// // // import React, { useEffect, useState } from 'react';
// // // import './menuiteams.css';

// // // import Modal from 'react-modal';
// // // import { ShoppingCart } from '@mui/icons-material';
// // // import { useNavigate } from 'react-router-dom';
// // // import axios from 'axios';

// // // Modal.setAppElement('#root');
// // // const MenuItems = ({ parentId }) => {
// // //     const [dishes, setDishes] = useState([]);
// // //     const [filteredDishes, setFilteredDishes] = useState([]);
// // //     const [quantities, setQuantities] = useState({});
// // //     const [loading, setLoading] = useState(true);
// // //     const [error, setError] = useState(null);
// // //     const [isVegSelected, setIsVegSelected] = useState(false);
// // //     const [isNonVegSelected, setIsNonVegSelected] = useState(false);
// // //     const [isModalOpen, setIsModalOpen] = useState(false);
// // //     const [selectedDish, setSelectedDish] = useState(null);
// // //     const [cartItems, setCartItems] = useState([]);
// // //     const [isHovered, setIsHovered] = useState(false);
// // //     const navigate = useNavigate();
// // //     const [enable, setEnable] = useState([]);
// // //     const [cartData, setCartData] = useState({ cartItems: [] });
// // //     const [selectedOrderType, setSelectedOrderType] = useState("");
// // //     const [refresh, setRefresh] = useState(false);
// // //     const [activeTab, setActiveTab] = useState(" ");

// // //     // FIXED: Improved filter function
// // //     const handleFilterClick = (type) => {
// // //         if (type === 'Veg') {
// // //             setIsVegSelected(true);
// // //             setIsNonVegSelected(false);
// // //             applyFilter('Veg');
// // //         } else if (type === 'Non-Veg') {
// // //             setIsVegSelected(false);
// // //             setIsNonVegSelected(true);
// // //             applyFilter('Non_Veg');
// // //         } else {
// // //             // Show all dishes
// // //             setIsVegSelected(false);
// // //             setIsNonVegSelected(false);
// // //             setFilteredDishes(dishes);
// // //         }
// // //     };

// // //     // FIXED: Separate filter application function
// // //     const applyFilter = (filterType) => {
// // //         if (filterType === 'Veg') {
// // //             setFilteredDishes(dishes.filter(dish => dish.tag === 'Veg'));
// // //         } else if (filterType === 'Non_Veg') {
// // //             setFilteredDishes(dishes.filter(dish => dish.tag === 'Non_Veg'));
// // //         } else {
// // //             setFilteredDishes(dishes);
// // //         }
// // //     };

// // //     // FIXED: Apply filter whenever dishes or filter state changes
// // //     useEffect(() => {
// // //         if (dishes.length > 0) {
// // //             if (isVegSelected) {
// // //                 applyFilter('Veg');
// // //             } else if (isNonVegSelected) {
// // //                 applyFilter('Non_Veg');
// // //             } else {
// // //                 setFilteredDishes(dishes);
// // //             }
// // //         }
// // //     }, [dishes, isVegSelected, isNonVegSelected]);

// // //     const totalPrice = cartItems.reduce((acc, item) => {
// // //         return acc + item.price * item.quantity * 0.9;
// // //     }, 0);

// // //     const [isOn, setIsOn] = useState(false);
// // //     const handleToggle = () => {
// // //         setIsOn(prev => !prev);
// // //     };

// // //     const authToken = localStorage.getItem("authToken");
// // //     const vendorId = localStorage.getItem("vendorId");
// // //     const handleOrderTypeChange = async (type) => {
// // //         const vendorId = localStorage.getItem("vendorId");
// // //         const token = localStorage.getItem("authToken");

// // //         if (!vendorId || !token) {
// // //             alert("Vendor not logged in!");
// // //             return;
// // //         }

// // //         try {
// // //             const orderTypeValue = type === "Dine In" ? "DINE_IN" : "TAKEAWAY";

// // //             await axios.put(
// // //                 `https://backend.maamaas.com/food/api/cart/update/orderType/${vendorId}?orderType=${orderTypeValue}`,
// // //                 {},
// // //                 { headers: { Authorization: `Bearer ${token}` } }
// // //             );

// // //             setSelectedOrderType(type);
// // //             setRefresh(prev => prev + 1);

// // //         } catch (error) {
// // //             console.error("❌ Error updating order type:", error);
// // //             alert("Failed to update order type. Please try again.");
// // //         }
// // //     };

// // //     const fetchCartData = async () => {
// // //         if (!authToken || !vendorId) return;

// // //         try {
// // //             const response = await axios.get(
// // //                 `https://backend.maamaas.com/food/api/cart/vendor/${vendorId}`,
// // //                 { headers: { Authorization: `Bearer ${authToken}` } }
// // //             );

// // //             setCartData(response.data);

// // //             const initialQuantities = {};
// // //             if (response.data.cartItems) {
// // //                 response.data.cartItems.forEach(item => {
// // //                     initialQuantities[item.dishId] = item.quantity;
// // //                 });
// // //             }
// // //             setQuantities(initialQuantities);

// // //         } catch (err) {
// // //             // console.error("Error fetching cart:", err);
// // //         }
// // //     };


// // //     const increaseQuantity = async (dishId) => {
// // //         const token = localStorage.getItem("authToken");
// // //         const vendorId = localStorage.getItem("vendorId");
// // //         if (!token || !vendorId) return alert("Auth token or vendorId missing");

// // //         if (!cartData || !cartData.cartItems) {
// // //             alert("Cart is empty or not loaded yet.");
// // //             return;
// // //         }

// // //         const cartItem = cartData.cartItems.find(item => item.dishId === dishId);
// // //         if (!cartItem) {
// // //             alert("Item not found in cart. Please add it first.");
// // //             return;
// // //         }

// // //         const newQty = (quantities[dishId] || 0) + 1;

// // //         // Correct API URL with vendorId and cartId
// // //         const apiUrl = `https://backend.maamaas.com/food/api/cart/update/cart/${vendorId}/${cartData.cartId}?dishId=${dishId}&quantity=${newQty}`;

// // //         console.log("API URL:", apiUrl);

// // //         try {
// // //             const response = await axios.put(apiUrl, null, {
// // //                 headers: { Authorization: `Bearer ${token}` }
// // //             });

// // //             console.log("API Response:", response.data);

// // //             // Update state
// // //             setQuantities(prev => ({ ...prev, [dishId]: newQty }));
// // //             setCartData(prev => ({
// // //                 ...prev,
// // //                 cartItems: prev.cartItems.map(item =>
// // //                     item.dishId === dishId ? { ...item, quantity: newQty } : item
// // //                 )
// // //             }));
// // //             setIsModalOpen(true);
// // //             setTimeout(() => {
// // //                 if (!isHovered) setIsModalOpen(false);
// // //             }, 2000);
// // //         } catch (err) {
// // //             console.error("API Error:", err.response ? err.response.data : err);
// // //             alert("Unable to update quantity for dishId: " + dishId);
// // //         }
// // //     };




// // //     const decreaseQuantity = async (dishId) => {
// // //         const token = localStorage.getItem("authToken");
// // //         const vendorId = localStorage.getItem("vendorId");
// // //         const currentQty = quantities[dishId] || 0;
// // //         if (currentQty === 0) return;

// // //         if (!cartData || !cartData.cartItems) {
// // //             alert("Cart is empty or not loaded yet.");
// // //             return;
// // //         }

// // //         const cartItem = cartData.cartItems.find(item => item.dishId === dishId);
// // //         if (!cartItem) return alert("Item not found");

// // //         const newQty = currentQty - 1;

// // //         // Correct API URL with vendorId and cartId
// // //         const apiUrl = `https://backend.maamaas.com/food/api/cart/update/cart/${vendorId}/${cartData.cartId}?dishId=${dishId}&quantity=${newQty}`;

// // //         // console.log("=== Decrease Quantity API Call ===");
// // //         // console.log("dishId:", dishId);
// // //         // console.log("newQty:", newQty);
// // //         // console.log("cartId:", cartData.cartId);
// // //         // console.log("API URL:", apiUrl);

// // //         try {
// // //             const response = await axios.put(apiUrl, null, {
// // //                 headers: { Authorization: `Bearer ${token}` }
// // //             });

// // //             console.log("API Response:", response.data);

// // //             setQuantities(prev => ({ ...prev, [dishId]: newQty > 0 ? newQty : 0 }));
// // //             setCartData(prev => ({
// // //                 ...prev,
// // //                 cartItems: newQty > 0
// // //                     ? prev.cartItems.map(item =>
// // //                         item.dishId === dishId ? { ...item, quantity: newQty } : item
// // //                     )
// // //                     : prev.cartItems.filter(item => item.dishId !== dishId)
// // //             }));
// // //             setIsModalOpen(true);
// // //             setTimeout(() => {
// // //                 if (!isHovered) setIsModalOpen(false);
// // //             }, 2000);
// // //         } catch (err) {
// // //             console.error("API Error:", err.response ? err.response.data : err);
// // //             alert("Unable to update quantity for dishId: " + dishId);
// // //         }
// // //     };


// // //     useEffect(() => {
// // //         fetchCartData();
// // //     }, [authToken, vendorId]);






// // //     const addToCart = async (item, quantity = 1) => {
// // //         const vendorId = localStorage.getItem("vendorId");
// // //         const token = localStorage.getItem("authToken");

// // //         // 🔥 Safe mapping for order types
// // //         const formatOrderType = (type) => {
// // //             if (!type) return "DINE_IN";
// // //             const cleaned = type.toLowerCase().replace(/\s+/g, "");
// // //             return cleaned === "dinein" ? "DINE_IN" : "TAKEAWAY";
// // //         };

// // //         const orderType = formatOrderType(selectedOrderType);

// // //         console.log("ORDER TYPE SENT:", orderType); // 🔥 check here

// // //         const apiUrl = `https://backend.maamaas.com/food/api/cart/add/vendor/${vendorId}?orderType=${orderType}`;
// // //         const data = { dishId: item.dishId, quantity };

// // //         try {
// // //             const response = await axios.post(apiUrl, data, {
// // //                 headers: {
// // //                     "Content-Type": "application/json",
// // //                     "Authorization": `Bearer ${token}`,
// // //                 },
// // //             });

// // //             if (response.status === 200) {
// // //                 await fetchCartData();
// // //                 setIsModalOpen(true);
// // //                 setTimeout(() => {
// // //                     if (!isHovered) setIsModalOpen(false);
// // //                 }, 2000);
// // //             } else {
// // //                 alert("Failed to add item to cart");
// // //             }
// // //         } catch (error) {
// // //             console.error("Error adding item to cart:", error);
// // //             alert("Error adding item to cart");
// // //         }
// // //     };

// // //     useEffect(() => {
// // //         const fetchData = async () => {
// // //             const vendorId = localStorage.getItem("vendorId");
// // //             const token = localStorage.getItem("authToken");

// // //             if (!vendorId) {
// // //                 console.warn("⚠️ vendorId not found in localStorage");
// // //                 setError(new Error("vendorId missing"));
// // //                 setLoading(false);
// // //                 return;
// // //             }

// // //             if (!token) {
// // //                 console.warn("⚠️ authToken not found in localStorage");
// // //                 setError(new Error("authToken missing"));
// // //                 setLoading(false);
// // //                 return;
// // //             }

// // //             try {
// // //                 const response = await fetch(
// // //                     `https://backend.maamaas.com/food/api/dish/getbyvendor/${vendorId}`,
// // //                     {
// // //                         headers: {
// // //                             'Authorization': `Bearer ${token}`,
// // //                             'Content-Type': 'application/json',
// // //                             'Accept': 'application/json',
// // //                         },
// // //                     }
// // //                 );

// // //                 if (!response.ok) {
// // //                     throw new Error(`HTTP error! status: ${response.status}`);
// // //                 }

// // //                 const data = await response.json();
// // //                 // console.log('API Data:', data);

// // //                 const dishData = Array.isArray(data) ? data : data.data || [];
// // //                 // console.log('Dish Data:', dishData);

// // //                 const validDishData = dishData.filter(item => item !== null && item !== undefined);
// // //                 // console.log('Valid Dish Data:', validDishData);

// // //                 const filteredData = validDishData.filter(item => {
// // //                     const parentCheck = parentId ? Number(item.parentId) === Number(parentId) : Number(item.parentId) !== 0;
// // //                     const statusCheck = item.menuStatus === "Enable";
// // //                     const quantityCheck = Number(item.balanceQuantity) > 0;
// // //                     return parentCheck && statusCheck && quantityCheck;
// // //                 });

// // //                 // console.log('Filtered Dishes (balanceQuantity > 0):', filteredData);
// // //                 setDishes(filteredData);
// // //                 // FIXED: Don't set filteredDishes here - let the useEffect handle it based on filter state
// // //             } catch (error) {
// // //                 console.error('Error fetching data:', error);
// // //                 setError(error);
// // //             } finally {
// // //                 setLoading(false);
// // //             }
// // //         };

// // //         fetchData();
// // //     }, [parentId]);

// // //     const handleViewCartClick = () => {
// // //         navigate('/foodcart');
// // //     };

// // //     if (loading) {
// // //         return <div>Loading...</div>;
// // //     }

// // //     if (error) {
// // //         return <div>Error loading dishes: {error.message}</div>;
// // //     }

// // //     return (
// // //         <div style={{ marginTop: '100px' }} className='menuiteams-data'>
// // //             <div
// // //                 style={{
// // //                     display: "flex",
// // //                     flexWrap: "wrap",
// // //                     gap: "1rem",
// // //                     marginBottom: "1rem",
// // //                     // justifyContent: "center",
// // //                 }}
// // //             >
// // //                 <style>
// // //                     {`
// // //                         @media (max-width: 768px) {
// // //                             .offers-containers {
// // //                                 grid-template-columns: repeat(2, 1fr) !important;
// // //                                 gap: 15px !important;
// // //                             }
// // //                             .offers-cards {
// // //                                 width: 100% !important;
// // //                                 max-width: 100% !important;
// // //                             }
// // //                             .responsive-button-group {
// // //                                 flex-direction: column !important;
// // //                                 align-items: center !important;
// // //                                 width:90vw !important;
// // //                             }
// // //                             .responsive-button {
// // //                                 width: 45% !important;
// // //                                 text-align: center;
// // //                             }
// // //                             .custom-switch-wrapper {
// // //                                 margin-top: 10px;
// // //                            left: "-20px"
// // //                             }
// // //                         }
// // //  @media (min-width: 980px) {


// // //                                .custom-switch-wrapper {

// // //                            margin-left: -20px !important;
// // //                             }
// // //                     }
// // //  @media (min-width: 980px) {
// // //                     .add-iteams-data{
// // //                     margin-left:8vw!important;
// // //                     }
// // //                     .dst{
// // //                     margin-left:-11px !important;
// // //                     }
// // //                     }
// // //                         @media (max-width: 480px) {
// // //                             .offers-containers {
// // //                                 grid-template-columns: 1fr !important;
// // //                             }
// // //                             .offers-cards {
// // //                                 margin: 0 auto !important;
// // //                             }
// // //                             .card-body {
// // //                                 padding: 10px !important;
// // //                             }
// // //                             .card-title {
// // //                                 font-size: 18px !important;
// // //                             }
// // //                         }

// // //                         @media (max-width: 320px) {
// // //                             .offers-cards {
// // //                                 width: 95% !important;
// // //                             }
// // //                             .card-body {
// // //                                 padding: 8px !important;
// // //                             }
// // //                             .card-title {
// // //                                 font-size: 16px !important;
// // //                             }
// // //                         }

// // //                         .custom-switch {
// // //                             position: relative;
// // //                             display: inline-block;
// // //                             width: 100px;
// // //                             height: 35px;
// // //                         }

// // //                         .custom-switch input {
// // //                             opacity: 0;
// // //                             width: 0;
// // //                             height: 0;
// // //                         }

// // //                         .custom-slideryy {
// // //                             position: absolute;
// // //                             cursor: pointer;
// // //                             transition: 0.4s;
// // //                             font-weight: bold;
// // //                             font-size: 14px;
// // //                             color: #000;
// // //                             textAlign: "center",
// // //                             lineHeight: 35px;
// // //                             width: 100px;
// // //                             height: 40px;
// // //                             borderRadius: 5px;
// // //                             backgroundColor: rgb(217, 217, 217);
// // //                         }

// // //                         .custom-slideryy::before {
// // //                             content: "";
// // //                             position: absolute;
// // //                             height: 16px;
// // //                             width: 16px;
// // //                             left: 8px;
// // //                             top: 13px;
// // //                             backgroundColor: #000;
// // //                             transition: 0.4s;
// // //                             borderRadius: 50%;
// // //                         }

// // //                         .custom-slideryy.veg::before {
// // //                             backgroundColor: green;
// // //                         }

// // //                         .custom-slideryy.non-veg::before {
// // //                             backgroundColor: red;
// // //                         }

// // //                         .custom-switch input:checked + .custom-slideryy::before {
// // //                             transform: translateX(60px);
// // //                         }
// // //                     `}
// // //                 </style>

// // //                 <div className="responsive-button-group menu-responsive-buttons-code" style={{
// // //                     display: "flex",
// // //                     flexDirection: "row",
// // //                     justifyContent: "space-between",
// // //                     alignItems: "center",
// // //                     marginLeft: "15px",
// // //                     width: "100%",
// // //                     gap: "10px",
// // //                     marginTop: window.innerWidth >= 768 && window.innerWidth < 769 ? "25px" : "-17px",
// // //                 }}>
// // //                     {/* Left Group - Menu and Add Items */}
// // //                     <div style={{
// // //                         display: "flex",
// // //                         flexDirection: "row",
// // //                         gap: "10px",
// // //                         alignItems: "center"
// // //                     }}>
// // //                         <div
// // //                             className="responsive-button"
// // //                             style={{
// // //                                 padding: "9px 16px",
// // //                                 border: "none",
// // //                                 backgroundColor: "#b15cd6",
// // //                                 color: "#fff",
// // //                                 borderRadius: "5px",
// // //                                 cursor: "pointer",
// // //                                 transition: "all 0.3s",
// // //                                 fontWeight: "bold",
// // //                             }}
// // //                         >
// // //                             Menu
// // //                         </div>

// // //                         <div
// // //                             className="additembutton"
// // //                             style={{
// // //                                 padding: "10px 17px",
// // //                                 border: "none",
// // //                                 backgroundColor: activeTab === "first" ? "#b15cd6" : "#d9d9d9",
// // //                                 color: activeTab === "first" ? "white" : "#000",
// // //                                 borderRadius: "5px",
// // //                                 cursor: "pointer",
// // //                                 transition: "all 0.3s",
// // //                                 fontWeight: "bold",
// // //                                 boxShadow: activeTab === "first" ? "0 2px 5px rgba(0,0,0,0.2)" : "none",
// // //                                 width: window.innerWidth <= 558 ? "100px" : "auto",
// // //                                 textAlign: "center",
// // //                             }}
// // //                             onClick={() => navigate("/foodandbeveragesMenu")}
// // //                         >
// // //                             Add Items
// // //                         </div>
// // //                     </div>

// // //                     {/* Right Group - Veg/Non-Veg toggle and Order Type buttons */}
// // //                     <div style={{
// // //                         display: "flex",
// // //                         flexDirection: "row",
// // //                         gap: "15px",
// // //                         alignItems: "center",
// // //                         justifyContent: "center",
// // //                         width: "auto"
// // //                     }}>
// // //                         {/* Veg/Non-Veg Toggle */}
// // //                         <div className="custom-switch-wrapper" style={{
// // //                             position: "relative",
// // //                             top: window.innerWidth <= 768 ? "-10px" : "-5px",
// // //                             display: "flex",
// // //                             justifyContent: "center"
// // //                         }}>
// // //                             <label className="custom-switch" style={{
// // //                                 display: "flex",
// // //                                 justifyContent: "center",
// // //                                 alignItems: "center"
// // //                             }}>
// // //                                 <input
// // //                                     type="checkbox"
// // //                                     checked={isVegSelected}
// // //                                     onChange={() => handleFilterClick(isVegSelected ? "Non-Veg" : "Veg")}
// // //                                     style={{
// // //                                         marginRight: "8px",
// // //                                         cursor: "pointer"
// // //                                     }}
// // //                                 />
// // //                                 <span className={`custom-slideryy ${isVegSelected ? "veg" : "non-veg"}`} style={{
// // //                                     padding: "2px 14px",
// // //                                     fontSize: "13px",
// // //                                     textAlign: "center",
// // //                                     justifyContent: "center",
// // //                                     display: "inline-block",
// // //                                     borderRadius: "5px",
// // //                                     fontWeight: "bold",
// // //                                     backgroundColor: isVegSelected ? "#4CAF50" : "#f44336",
// // //                                     color: "white",
// // //                                     transition: "all 0.3s",
// // //                                     whiteSpace: "nowrap",
// // //                                     minWidth: "80px",
// // //                                    paddingTop:"10%",
// // //                                 }}>
// // //                                     {isVegSelected ? "Veg" : "Non-Veg"}
// // //                                 </span>
// // //                             </label>
// // //                         </div>

// // //                         {/* Order Type Buttons */}
// // //                         <div style={{
// // //                             display: "flex",
// // //                             flexDirection: "row",
// // //                             gap: "10px",
// // //                             alignItems: "center"
// // //                         }}>
// // //                             {["Dine In", "Take Away"].map((type) => (
// // //                                 <div
// // //                                     key={type}
// // //                                     style={{
// // //                                         display: "flex",
// // //                                         alignItems: "center",
// // //                                         gap: "8px",
// // //                                         padding: "9px 13px",
// // //                                         borderRadius: "5px",
// // //                                         border: "1px solid #ccc",
// // //                                         backgroundColor: selectedOrderType === type ? "#c2c0c0ff" : "#d9d9d9",
// // //                                         color: "#000",
// // //                                         cursor: "pointer",
// // //                                         fontWeight: "bold",
// // //                                         fontSize: "14px",
// // //                                         transition: "0.3s",
// // //                                         width: type === "Dine In" ? "100px" : "110px",
// // //                                         textAlign: "center",
// // //                                         justifyContent: "center",
// // //                                         whiteSpace: "nowrap",
// // //                                         flexShrink: 0
// // //                                     }}
// // //                                     onClick={() => setSelectedOrderType(type)}
// // //                                 >
// // //                                     <input
// // //                                         type="checkbox"
// // //                                         checked={selectedOrderType === type}
// // //                                         onChange={() => setSelectedOrderType(type)}
// // //                                         style={{
// // //                                             cursor: "pointer"
// // //                                         }}
// // //                                     />
// // //                                     <span style={{ whiteSpace: "nowrap" }}>{type}</span>
// // //                                 </div>
// // //                             ))}
// // //                         </div>
// // //                     </div>
// // //                 </div>
// // //             </div>

// // //             <div className="offers-containers" style={{
// // //                 display: 'grid',
// // //                 gridTemplateColumns: 'repeat(auto-fill, minmax(203px, 1fr))',
// // //                 gap: '20px',
// // //                 padding: '20px',
// // //                 marginTop: '7px'
// // //             }}>
// // //                 {filteredDishes.map((item) => (
// // //                     <div key={item.dishId} className="offers-cards" style={{
// // //                         width: '100%',
// // //                         maxWidth: '300px',
// // //                         margin: '0 auto',
// // //                         borderRadius: '10px',
// // //                         overflow: 'hidden',
// // //                         boxShadow: '0 4px 8px rgba(0, 0, 0, 0.1)'
// // //                     }}>
// // //                         {/* Rest of your card content remains the same */}
// // //                         <div className="inner-box" style={{ position: 'relative' }}>
// // //                             {item.dishImage ? (
// // //                                 <img
// // //                                     src={item.dishImage}
// // //                                     alt="Dish"
// // //                                     className="offer-image"
// // //                                     style={{ width: '100%', height: '200px', objectFit: 'cover' }}
// // //                                 />
// // //                             ) : (
// // //                                 <img
// // //                                     src="default-image.jpg"
// // //                                     alt="Default"
// // //                                     className="offer-image"
// // //                                     style={{ width: '100%', height: '200px', objectFit: 'cover' }}
// // //                                 />
// // //                             )}
// // //                         </div>

// // //                         <div
// // //                             className="card-body"
// // //                             style={{
// // //                                 marginTop: '8px',
// // //                                 padding: '15px',
// // //                                 borderRadius: '10px',
// // //                                 backgroundColor: '#fff',
// // //                             }}
// // //                         >
// // //                             <h5
// // //                                 className="card-title text-dark"
// // //                                 style={{
// // //                                     fontSize: "20px",
// // //                                     marginBottom: "10px",
// // //                                     display: "flex",
// // //                                     alignItems: "center",
// // //                                     justifyContent: "space-between",
// // //                                 }}
// // //                             >
// // //                                 <span>{item.dishName}</span>

// // //                                 {item.tag === "Veg" ? (
// // //                                     <span
// // //                                         style={{
// // //                                             display: "inline-block",
// // //                                             width: "16px",
// // //                                             height: "16px",
// // //                                             border: "2px solid green",
// // //                                             borderRadius: "2px",
// // //                                             position: "relative",
// // //                                         }}
// // //                                     >
// // //                                         <span
// // //                                             style={{
// // //                                                 display: "block",
// // //                                                 width: "8px",
// // //                                                 height: "8px",
// // //                                                 backgroundColor: "green",
// // //                                                 borderRadius: "50%",
// // //                                                 position: "absolute",
// // //                                                 top: "50%",
// // //                                                 left: "50%",
// // //                                                 transform: "translate(-50%, -50%)",
// // //                                             }}
// // //                                         ></span>
// // //                                     </span>
// // //                                 ) : (
// // //                                     <span
// // //                                         style={{
// // //                                             display: "inline-block",
// // //                                             width: "16px",
// // //                                             height: "16px",
// // //                                             border: "2px solid red",
// // //                                             borderRadius: "2px",
// // //                                             position: "relative",
// // //                                         }}
// // //                                     >
// // //                                         <span
// // //                                             style={{
// // //                                                 display: "block",
// // //                                                 width: "8px",
// // //                                                 height: "8px",
// // //                                                 backgroundColor: "red",
// // //                                                 borderRadius: "50%",
// // //                                                 position: "absolute",
// // //                                                 top: "50%",
// // //                                                 left: "50%",
// // //                                                 transform: "translate(-50%, -50%)",
// // //                                             }}
// // //                                         ></span>
// // //                                     </span>
// // //                                 )}
// // //                             </h5>

// // //                             <span className="d-flex justify-content-between" style={{ color: 'black' }}>
// // //                                 <span>
// // //                                     <span style={{ position: 'relative', fontSize: '21px', color: "gray" }}>
// // //                                         <i className="fa-solid fa-indian-rupee-sign" style={{ fontSize: '15px' }}></i>
// // //                                         {item.price}
// // //                                         <span style={{
// // //                                             content: '',
// // //                                             position: 'absolute',
// // //                                             top: '15px',
// // //                                             left: 0,
// // //                                             width: '100%',
// // //                                             borderTop: '1px solid black',
// // //                                         }} />
// // //                                     </span>

// // //                                     <span style={{ fontSize: '20px', position: 'relative', marginLeft: '15px' }}>
// // //                                         <i className="fa-solid fa-indian-rupee-sign" style={{ fontSize: "15px" }}></i>
// // //                                         {item.effectivePrice}
// // //                                     </span>
// // //                                 </span>
// // //                             </span>

// // //                             <br></br>

// // //                             <div style={{ textAlign: "center", marginTop: "10px" }}>
// // //                                 {cartData.cartItems?.some(ci => ci.dishId === item.dishId) || quantities[item.dishId] > 0 ? (
// // //                                     <div
// // //                                         className="d-flex justify-content-between align-items-center border p-2 mt-2"
// // //                                         style={{
// // //                                             borderRadius: '50px',
// // //                                             backgroundColor: '#b15dc6',
// // //                                             width: '80%',
// // //                                             height: '37px',
// // //                                             marginLeft: 'auto',
// // //                                             marginRight: 'auto',
// // //                                         }}
// // //                                     >
// // //                                         <button
// // //                                             onClick={() => decreaseQuantity(item.dishId)}
// // //                                             style={{
// // //                                                 width: '40px',
// // //                                                 height: '40px',
// // //                                                 fontSize: '25px',
// // //                                                 fontWeight: 'bold',
// // //                                                 color: '#fff',
// // //                                                 marginTop: '-10px',
// // //                                                 border: 'none',
// // //                                                 background: 'none',
// // //                                                 cursor: 'pointer',
// // //                                             }}
// // //                                         >
// // //                                             -
// // //                                         </button>
// // //                                         <span
// // //                                             style={{
// // //                                                 fontSize: '25px',
// // //                                                 fontWeight: 'bold',
// // //                                                 minWidth: '40px',
// // //                                                 textAlign: 'center',
// // //                                                 color: '#fff',
// // //                                             }}
// // //                                         >
// // //                                             {quantities[item.dishId] || 1}
// // //                                         </span>
// // //                                         <button
// // //                                             onClick={() => increaseQuantity(item.dishId)}
// // //                                             style={{
// // //                                                 width: '40px',
// // //                                                 height: '40px',
// // //                                                 fontSize: '25px',
// // //                                                 fontWeight: 'bold',
// // //                                                 color: '#fff',
// // //                                                 marginTop: '-10px',
// // //                                                 border: 'none',
// // //                                                 background: 'none',
// // //                                                 cursor: 'pointer',
// // //                                             }}
// // //                                         >
// // //                                             +
// // //                                         </button>
// // //                                     </div>
// // //                                 ) : (
// // //                                     <button
// // //                                         className="btn mt-2 d-block mx-auto"
// // //                                         onClick={async () => {
// // //                                             setQuantities(prev => ({ ...prev, [item.dishId]: 1 }));
// // //                                             await addToCart(item, 1);
// // //                                         }}
// // //                                         style={{
// // //                                             background: "#b15dc6",
// // //                                             color: "#fff",
// // //                                             width: "80%",
// // //                                             borderRadius: "50px",
// // //                                             padding: "8px 0",
// // //                                         }}
// // //                                     >
// // //                                         Add To Cart
// // //                                     </button>
// // //                                 )}
// // //                             </div>
// // //                         </div>
// // //                     </div>
// // //                 ))}
// // //             </div>

// // //             {/* Modal remains the same */}
// // //             <Modal
// // //                 isOpen={isModalOpen}
// // //                 onRequestClose={() => setIsModalOpen(false)}
// // //                 contentLabel="Add to Cart"
// // //                 shouldCloseOnOverlayClick={false}
// // //                 shouldCloseOnEsc={false}
// // //                 style={{
// // //                     overlay: {
// // //                         backgroundColor: "transparent",
// // //                         pointerEvents: "none",
// // //                     },
// // //                     content: {
// // //                         pointerEvents: "auto",
// // //                         position: "sticky",
// // //                         bottom: "20px",
// // //                         top: "620px",
// // //                         left: "30%",
// // //                         width: "90%",
// // //                         maxWidth: "500px",
// // //                         border: "none",
// // //                         boxShadow: "0 4px 8px rgba(0, 0, 0, 0.2)",
// // //                         padding: "10px",
// // //                         height: "auto",
// // //                         borderRadius: "10px",
// // //                     },
// // //                 }}
// // //                 onMouseEnter={() => setIsHovered(true)}
// // //                 onMouseLeave={() => setIsHovered(false)}
// // //             >
// // //                 <div
// // //                     style={{
// // //                         display: "flex",
// // //                         alignItems: "center",
// // //                         justifyContent: "space-between",
// // //                         padding: "10px",
// // //                         width: "100%",
// // //                         fontWeight: "bold",
// // //                         color: "#333",
// // //                         borderRadius: "10px",
// // //                         height: "auto",
// // //                         border: "2px solid #b15cd6",
// // //                         flexWrap: "wrap"
// // //                     }}
// // //                 >
// // //                     <ShoppingCart style={{ fontSize: "30px", color: "#b15dc6", marginRight: "10px" }} />

// // //                     <div style={{ marginRight: "10px", fontSize: "18px" }}>
// // //                         ({cartData.cartItems?.reduce((acc, item) => acc + (quantities[item.dishId] || item.quantity || 0), 0)}) Items
// // //                     </div>

// // //                     <div style={{ marginRight: "10px", fontSize: "18px" }}>
// // //                         Total: ₹
// // //                         {cartData.cartItems
// // //                             ?.reduce((acc, item) => {
// // //                                 const quantity = quantities[item.dishId] ?? item.quantity ?? 0;
// // //                                 const price = parseFloat(item.effectivePrice ?? item.price ?? 0);
// // //                                 return acc + price * quantity;
// // //                             }, 0)
// // //                             .toFixed(2)}
// // //                     </div>

// // //                     <button
// // //                         style={{
// // //                             borderRadius: "50px",
// // //                             background: "#b15dc6",
// // //                             color: "#fff",
// // //                             padding: "8px 16px",
// // //                             border: "none",
// // //                             cursor: "pointer",
// // //                             marginTop: "5px",
// // //                             width: "100%",
// // //                             maxWidth: "150px"
// // //                         }}
// // //                         onClick={handleViewCartClick}
// // //                     >
// // //                         View Cart
// // //                     </button>
// // //                 </div>
// // //             </Modal>

// // //         </div>
// // //     );
// // // };

// // // export default MenuItems;















// // import React, { useEffect, useState } from 'react';
// // import './menuiteams.css';

// // import Modal from 'react-modal';
// // import { ShoppingCart } from '@mui/icons-material';
// // import { useNavigate } from 'react-router-dom';
// // import axios from 'axios';
// // import { FormControlLabel, Switch, Typography } from "@mui/material";

// // Modal.setAppElement('#root');
// // const MenuItems = ({ parentId }) => {
// //     const [dishes, setDishes] = useState([]);
// //     const [filteredDishes, setFilteredDishes] = useState([]);
// //     const [quantities, setQuantities] = useState({});
// //     const [loading, setLoading] = useState(true);
// //     const [error, setError] = useState(null);
// //     const [isVegSelected, setIsVegSelected] = useState(false);
// //     const [isNonVegSelected, setIsNonVegSelected] = useState(false);
// //     const [isModalOpen, setIsModalOpen] = useState(false);
// //     const [cartData, setCartData] = useState({ cartItems: [] });
// //     const [isHovered, setIsHovered] = useState(false);
// //     const navigate = useNavigate();
// //     const [selectedOrderType, setSelectedOrderType] = useState("");
// //     const [refresh, setRefresh] = useState(false);
// //     const [activeTab, setActiveTab] = useState(" ");
// //     const [showRemoveConfirm, setShowRemoveConfirm] = useState(false);
// //     const [itemToRemove, setItemToRemove] = useState(null);
// //     const [grandTotal, setGrandTotal] = useState(0);
// //     // Add this with other state declarations
// //     const [searchQuery, setSearchQuery] = useState("");
// //     const applyCurrentFilters = () => {
// //         let filtered = dishes;

// //         if (isVegSelected) {
// //             filtered = filtered.filter(dish => dish.tag === 'Veg');
// //         } else if (isNonVegSelected) {
// //             filtered = filtered.filter(dish => dish.tag === 'Non_Veg');
// //         }

// //         setFilteredDishes(filtered);
// //     };
// //     const handleSearch = () => {
// //         if (!searchQuery.trim()) {
// //             // If search is empty, show all items based on current filters
// //             applyCurrentFilters();
// //             return;
// //         }

// //         const searchTerm = searchQuery.toLowerCase().trim();

// //         // Filter dishes based on search term
// //         const searchResults = dishes.filter(dish =>
// //             dish.dishName.toLowerCase().includes(searchTerm)
// //         );

// //         if (searchResults.length > 0) {
// //             setFilteredDishes(searchResults);
// //         } else {
// //             setFilteredDishes([]);
// //         }
// //     };
// //     useEffect(() => {
// //         handleSearch();
// //     }, [searchQuery, dishes]);

// //     useEffect(() => {
// //         const handleCartUpdate = () => {
// //             setRefresh(prev => prev + 1);
// //         };

// //         window.addEventListener('cartUpdated', handleCartUpdate);
// //         return () => {
// //             window.removeEventListener('cartUpdated', handleCartUpdate);
// //         };
// //     }, []);

// //     const handleFilterClick = (type) => {
// //         if (type === 'Veg') {
// //             setIsVegSelected(true);
// //             setIsNonVegSelected(false);
// //             applyFilter('Veg');
// //         } else if (type === 'Non-Veg') {
// //             setIsVegSelected(false);
// //             setIsNonVegSelected(true);
// //             applyFilter('Non_Veg');
// //         } else {
// //             // Show all
// //             setIsVegSelected(false);
// //             setIsNonVegSelected(false);
// //             setFilteredDishes(dishes);
// //         }
// //     };

// //     useEffect(() => {
// //         if (dishes.length > 0) {
// //             if (isVegSelected) {
// //                 applyFilter('Veg');
// //             } else if (isNonVegSelected) {
// //                 applyFilter('Non_Veg');
// //             } else {
// //                 setFilteredDishes(dishes);
// //             }
// //         }
// //     }, [dishes, isVegSelected, isNonVegSelected]);

// //     const authToken = localStorage.getItem("authToken");
// //     const vendorId = localStorage.getItem("vendorId");

// //     const triggerCartRefresh = () => {
// //         const event = new CustomEvent('cartUpdated');
// //         window.dispatchEvent(event);
// //     }

// //     // SINGLE fetchCartData function - remove the duplicate one below
// //     const fetchCartData = async () => {
// //         const authToken = localStorage.getItem("authToken");
// //         const vendorId = localStorage.getItem("vendorId");

// //         if (!authToken || !vendorId) return;

// //         try {
// //             const response = await axios.get(
// //                 `https://backend.maamaas.com/food/api/cart/vendor/${vendorId}`,
// //                 { headers: { Authorization: `Bearer ${authToken}` } }
// //             );
// //             setCartData(response.data);
// //             setGrandTotal(response.data.grandTotal || 0); // Add this line

// //             const initialQuantities = {};
// //             if (response.data.cartItems) {
// //                 response.data.cartItems.forEach(item => {
// //                     initialQuantities[item.dishId] = item.quantity;
// //                 });
// //             }
// //             setQuantities(initialQuantities);
// //         } catch (err) {
// //             console.error("Error fetching cart:", err);
// //         }
// //     };

// //     const increaseQuantity = async (dishId) => {
// //         const token = localStorage.getItem("authToken");
// //         const vendorId = localStorage.getItem("vendorId");
// //         if (!token || !vendorId) return alert("Auth token or vendorId missing");

// //         if (!cartData || !cartData.cartItems) {
// //             alert("Cart is empty or not loaded yet.");
// //             return;
// //         }

// //         const cartItem = cartData.cartItems.find(item => item.dishId === dishId);
// //         if (!cartItem) {
// //             alert("Item not found in cart. Please add it first.");
// //             return;
// //         }

// //         const newQty = (quantities[dishId] || 0) + 1;

// //         const apiUrl = `https://backend.maamaas.com/food/api/cart/update/cart/${vendorId}/${cartData.cartId}?dishId=${dishId}&quantity=${newQty}`;

// //         console.log("API URL:", apiUrl);

// //         try {
// //             const response = await axios.put(apiUrl, null, {
// //                 headers: { Authorization: `Bearer ${token}` }
// //             });

// //             console.log("API Response:", response.data);

// //             // Update local state immediately
// //             setQuantities(prev => ({ ...prev, [dishId]: newQty }));
// //             setCartData(prev => ({
// //                 ...prev,
// //                 cartItems: prev.cartItems.map(item =>
// //                     item.dishId === dishId ? { ...item, quantity: newQty } : item
// //                 )
// //             }));

// //             // Refresh cart data to get updated totals
// //             await fetchCartData();

// //             setIsModalOpen(true);
// //             triggerCartRefresh();
// //             setTimeout(() => {
// //                 if (!isHovered) setIsModalOpen(false);
// //             }, 2000);
// //         } catch (err) {
// //             console.error("API Error:", err.response ? err.response.data : err);
// //             alert("Unable to update quantity for dishId: " + dishId);
// //         }
// //     };

// //     const decreaseQuantity = async (dishId) => {
// //         const token = localStorage.getItem("authToken");
// //         const vendorId = localStorage.getItem("vendorId");
// //         const currentQty = quantities[dishId] || 0;
// //         if (currentQty === 0) return;

// //         if (!cartData || !cartData.cartItems) {
// //             alert("Cart is empty or not loaded yet.");
// //             return;
// //         }

// //         const cartItem = cartData.cartItems.find(item => item.dishId === dishId);
// //         if (!cartItem) return alert("Item not found");

// //         const newQty = currentQty - 1;

// //         // If quantity becomes 0, show custom confirmation
// //         if (newQty === 0) {
// //             setItemToRemove({ dishId, cartItem });
// //             setShowRemoveConfirm(true);
// //             return;
// //         }

// //         // Continue with normal decrease
// //         await updateQuantity(dishId, newQty);
// //     };

// //     const confirmRemove = async () => {
// //         if (itemToRemove) {
// //             await updateQuantity(itemToRemove.dishId, 0);
// //             setShowRemoveConfirm(false);
// //             setItemToRemove(null);
// //         }
// //     };

// //     const cancelRemove = () => {
// //         setShowRemoveConfirm(false);
// //         setItemToRemove(null);
// //     };

// //     const updateQuantity = async (dishId, newQty) => {
// //         const token = localStorage.getItem("authToken");
// //         const vendorId = localStorage.getItem("vendorId");

// //         const apiUrl = `https://backend.maamaas.com/food/api/cart/update/cart/${vendorId}/${cartData.cartId}?dishId=${dishId}&quantity=${newQty}`;

// //         try {
// //             const response = await axios.put(apiUrl, null, {
// //                 headers: { Authorization: `Bearer ${token}` }
// //             });

// //             // Update local state immediately
// //             setQuantities(prev => ({ ...prev, [dishId]: newQty > 0 ? newQty : 0 }));
// //             setCartData(prev => ({
// //                 ...prev,
// //                 cartItems: newQty > 0
// //                     ? prev.cartItems.map(item =>
// //                         item.dishId === dishId ? { ...item, quantity: newQty } : item
// //                     )
// //                     : prev.cartItems.filter(item => item.dishId !== dishId)
// //             }));

// //             // Refresh cart data to get updated totals
// //             await fetchCartData();

// //             setIsModalOpen(true);
// //             triggerCartRefresh();
// //             setTimeout(() => {
// //                 if (!isHovered) setIsModalOpen(false);
// //             }, 2000);
// //         } catch (err) {
// //             console.error("API Error:", err.response ? err.response.data : err);
// //             alert("Unable to update quantity for dishId: " + dishId);
// //         }
// //     };

// //     useEffect(() => {
// //         fetchCartData();
// //     }, [authToken, vendorId, refresh]); // Add refresh to dependencies

// //     // Order Type Change Function
// //     const handleOrderTypeChange = async (type) => {
// //         const vendorId = localStorage.getItem("vendorId");
// //         const token = localStorage.getItem("authToken");

// //         if (!vendorId || !token) {
// //             alert("Vendor not logged in!");
// //             return;
// //         }

// //         try {
// //             const orderTypeValue = type === "Dine In" ? "DINE_IN" : "TAKEAWAY";

// //             console.log("Updating order type:", {
// //                 vendorId,
// //                 orderType: orderTypeValue,
// //                 currentCartId: cartData.cartId
// //             });

// //             await axios.put(
// //                 `https://backend.maamaas.com/food/api/cart/update/orderType/${vendorId}?orderType=${orderTypeValue}`,
// //                 {},
// //                 { headers: { Authorization: `Bearer ${token}` } }
// //             );

// //             // Update local state
// //             setSelectedOrderType(type);

// //             // Refresh cart data to get updated prices/charges
// //             await fetchCartData();

// //             // Trigger cart refresh for sidebar and navbar
// //             triggerCartRefresh();

// //             console.log("Order type updated successfully to:", type);

// //         } catch (error) {
// //             console.error("❌ Error updating order type:", error);
// //             alert("Failed to update order type. Please try again.");
// //         }
// //     };

// //     const addToCart = async (item, quantity = 1) => {
// //         const vendorId = localStorage.getItem("vendorId");
// //         const token = localStorage.getItem("authToken");

// //         const formatOrderType = (type) => {
// //             if (!type) return "DINE_IN";
// //             const cleaned = type.toLowerCase().replace(/\s+/g, "");
// //             return cleaned === "dinein" ? "DINE_IN" : "TAKEAWAY";
// //         };

// //         const orderType = formatOrderType(selectedOrderType);

// //         console.log("Adding to cart with order type:", orderType);

// //         const apiUrl = `https://backend.maamaas.com/food/api/cart/add/vendor/${vendorId}?orderType=${orderType}`;
// //         const data = { dishId: item.dishId, quantity };

// //         try {
// //             const response = await axios.post(apiUrl, data, {
// //                 headers: {
// //                     "Content-Type": "application/json",
// //                     "Authorization": `Bearer ${token}`,
// //                 },
// //             });

// //             if (response.status === 200) {
// //                 await fetchCartData();
// //                 triggerCartRefresh();
// //                 setIsModalOpen(true);
// //                 setTimeout(() => {
// //                     if (!isHovered) setIsModalOpen(false);
// //                 }, 2000);
// //             } else {
// //                 alert("Failed to add item to cart");
// //             }
// //         } catch (error) {
// //             console.error("Error adding item to cart:", error);
// //             alert("Error adding item to cart");
// //         }
// //     };

// //     useEffect(() => {
// //         const fetchData = async () => {
// //             const vendorId = localStorage.getItem("vendorId");
// //             const token = localStorage.getItem("authToken");

// //             if (!vendorId) {
// //                 console.warn("⚠️ vendorId not found in localStorage");
// //                 setError(new Error("vendorId missing"));
// //                 setLoading(false);
// //                 return;
// //             }

// //             if (!token) {
// //                 console.warn("⚠️ authToken not found in localStorage");
// //                 setError(new Error("authToken missing"));
// //                 setLoading(false);
// //                 return;
// //             }

// //             try {
// //                 const response = await fetch(
// //                     `https://backend.maamaas.com/food/api/dish/getbyvendor/${vendorId}`,
// //                     {
// //                         headers: {
// //                             'Authorization': `Bearer ${token}`,
// //                             'Content-Type': 'application/json',
// //                             'Accept': 'application/json',
// //                         },
// //                     }
// //                 );

// //                 if (!response.ok) {
// //                     throw new Error(`HTTP error! status: ${response.status}`);
// //                 }

// //                 const data = await response.json();
// //                 const dishData = Array.isArray(data) ? data : data.data || [];
// //                 const validDishData = dishData.filter(item => item !== null && item !== undefined);

// //                 const filteredData = validDishData.filter(item => {
// //                     const parentCheck = parentId ? Number(item.parentId) === Number(parentId) : Number(item.parentId) !== 0;
// //                     const statusCheck = item.menuStatus === "Enable";
// //                     const quantityCheck = Number(item.balanceQuantity) > 0;
// //                     return parentCheck && statusCheck && quantityCheck;
// //                 });

// //                 setDishes(filteredData);
// //             } catch (error) {
// //                 console.error('Error fetching data:', error);
// //                 setError(error);
// //             } finally {
// //                 setLoading(false);
// //             }
// //         };

// //         fetchData();
// //     }, [parentId]);

// //     const handleViewCartClick = () => {
// //         navigate('/foodcart');
// //     };

// //     if (loading) {
// //         return <div>Loading...</div>;
// //     }

// //     if (error) {
// //         return <div>Error loading dishes: {error.message}</div>;
// //     }
// //     // Add these functions after other state functions

// //     // Search function


// //     // Auto-search when searchQuery changes


// //     // Update applyCurrentFilters function

// //     const applyFilter = (filterType) => {
// //         let filtered = dishes;

// //         if (filterType === 'Veg') {
// //             filtered = dishes.filter(dish => dish.tag === 'Veg');
// //         } else if (filterType === 'Non_Veg') {
// //             filtered = dishes.filter(dish => dish.tag === 'Non_Veg');
// //         }

// //         // Apply search filter if there's a search query
// //         if (searchQuery.trim()) {
// //             const searchTerm = searchQuery.toLowerCase().trim();
// //             filtered = filtered.filter(dish =>
// //                 dish.dishName.toLowerCase().includes(searchTerm)
// //             );
// //         }

// //         setFilteredDishes(filtered);
// //     };

// //     return (
// //         <div style={{ marginTop: '6rem' }} className='menuiteams-data'>
// //             {/* Header buttons (keep your existing header) */}
// //             <div style={{
// //                 display: "flex",
// //                 flexWrap: "wrap",
// //                 gap: "1rem",
// //                 marginBottom: "1rem",
// //                 justifyContent: "space-between",
// //                 alignItems: "center",
// //                 padding: "0rem"
// //             }}>
// //                 <style>
// //                     {`
// //                         @media (max-width: 768px) {
// //                             .offers-containers {
// //                                 grid-template-columns: repeat(2, 1fr) !important;
// //                                 gap: 15px !important;
// //                             }
// //                             .offers-cards {
// //                                 width: 100% !important;
// //                                 max-width: 100% !important;
// //                             }
// //                             .responsive-button-group {
// //                                 flex-direction: column !important;
// //                                 align-items: center !important;
// //                                 width:90vw !important;
// //                             }
// //                             .responsive-button {
// //                                 width: 45% !important;
// //                                 text-align: center;
// //                             }
// //                             .custom-switch-wrapper {
// //                                 margin-top: 10px;
// //                            left: "-20px"
// //                             }
// //                         }
// //  @media (min-width: 980px) {


// //                                .custom-switch-wrapper {

// //                            margin-left: -20px !important;
// //                             }
// //                     }
// //  @media (min-width: 980px) {
// //                     .add-iteams-data{
// //                     margin-left:8vw!important;
// //                     }
// //                     .dst{
// //                     margin-left:-11px !important;
// //                     }
// //                     }
// //                         @media (max-width: 480px) {
// //                             .offers-containers {
// //                                 grid-template-columns: 1fr !important;
// //                             }
// //                             .offers-cards {
// //                                 margin: 0 auto !important;
// //                             }
// //                             .card-body {
// //                                 padding: 10px !important;
// //                             }
// //                             .card-title {
// //                                 font-size: 18px !important;
// //                             }
// //                         }

// //                         @media (max-width: 320px) {
// //                             .offers-cards {
// //                                 width: 95% !important;
// //                             }
// //                             .card-body {
// //                                 padding: 8px !important;
// //                             }
// //                             .card-title {
// //                                 font-size: 16px !important;
// //                             }
// //                         }

// //                         .custom-switch {
// //                             position: relative;
// //                             display: inline-block;
// //                             width: 100px;
// //                             height: 35px;
// //                         }

// //                         .custom-switch input {
// //                             opacity: 0;
// //                             width: 0;
// //                             height: 0;
// //                         }

// //                         .custom-slideryy {
// //                             position: absolute;
// //                             cursor: pointer;
// //                             transition: 0.4s;
// //                             font-weight: bold;
// //                             font-size: 14px;
// //                             color: #000;
// //                             textAlign: "center",
// //                             lineHeight: 35px;
// //                             width: 100px;
// //                             height: 40px;
// //                             borderRadius: 5px;
// //                             backgroundColor: rgb(217, 217, 217);
// //                         }

// //                         .custom-slideryy::before {
// //                             content: "";
// //                             position: absolute;
// //                             height: 16px;
// //                             width: 16px;
// //                             left: 8px;
// //                             top: 13px;
// //                             backgroundColor: #000;
// //                             transition: 0.4s;
// //                             borderRadius: 50%;
// //                         }

// //                         .custom-slideryy.veg::before {
// //                             backgroundColor: green;
// //                         }

// //                         .custom-slideryy.non-veg::before {
// //                             backgroundColor: red;
// //                         }

// //                         .custom-switch input:checked + .custom-slideryy::before {
// //                             transform: translateX(60px);
// //                         }
// //                     `}
// //                 </style>

// //                 <div className="responsive-button-group menu-responsive-buttons-code" style={{
// //                     display: "flex",
// //                     flexDirection: "column",
// //                     justifyContent: "start",
// //                     alignItems: "start",
// //                     marginLeft: "15px",
// //                     width: "100%",
// //                     gap: "10px",
// //                     marginTop: window.innerWidth >= 768 && window.innerWidth < 769 ? "25px" : "-17px",
// //                 }}>
// //                     {/* Left Group - Menu and Add Items */}
// //                     <div style={{
// //                         display: "flex",
// //                         flexDirection: "row",
// //                         gap: "10px",
// //                         alignItems: "center",
// //                         marginTop: "10px",
// //                         marginBottom: "-15px",
// //                     }}>
// //                         <div
// //                             className="responsive-button"
// //                             style={{
// //                                 padding: "6px 13px",
// //                                 border: "none",
// //                                 backgroundColor: "#b15cd6",
// //                                 color: "#fff",
// //                                 borderRadius: "5px",
// //                                 cursor: "pointer",
// //                                 transition: "all 0.3s",
// //                                 fontWeight: "bold",
// //                             }}
// //                         >
// //                             Menu
// //                         </div>

// //                         <div
// //                             className="additembutton"
// //                             style={{
// //                                 padding: "6px 13px",
// //                                 border: "none",
// //                                 backgroundColor: activeTab === "first" ? "#b15cd6" : "#d9d9d9",
// //                                 color: activeTab === "first" ? "white" : "#000",
// //                                 borderRadius: "5px",
// //                                 cursor: "pointer",
// //                                 transition: "all 0.3s",
// //                                 fontWeight: "bold",
// //                                 boxShadow: activeTab === "first" ? "0 2px 5px rgba(0,0,0,0.2)" : "none",
// //                                 width: window.innerWidth <= 558 ? "100px" : "auto",
// //                                 textAlign: "center",
// //                             }}
// //                             onClick={() => navigate("/foodandbeveragesMenu")}
// //                         >
// //                             Add Items
// //                         </div>
// //                     </div>

// //                     {/* Right Group - Veg/Non-Veg toggle, Order Type buttons, and Search */}
// //                     <div style={{
// //                         display: "flex",
// //                         flexDirection: window.innerWidth <= 990 ? "column" : "row",
// //                         gap: window.innerWidth <= 990 ? "15px" : "10px",
// //                         alignItems: "center",
// //                         justifyContent: "space-between",
// //                         width: "100%",
// //                         flexWrap: window.innerWidth <=1200 ? " " : "wrap"
// //                     }}>
// //                         {/* Toggle and Order Type Section */}
// //                         <div style={{
// //                             display: "flex",
// //                             flexDirection: "row",
// //                             gap: window.innerWidth <= 1200 ? "10px" : "15px",
// //                             alignItems: "center",
// //                             flexWrap: "nowrap",
// //                             flexShrink: 0
// //                         }}>
// //                             {/* Veg/Non-Veg Toggle */}
// //                             <div
// //                                 className="toggle-container"
// //                                 style={{
// //                                     position: "relative",
// //                                     display: "flex",
// //                                     justifyContent: "center",
// //                                     alignItems: "center",
// //                                     flexShrink: 0
// //                                 }}
// //                             >
// //                                 <label
// //                                     className="veg-toggle"
// //                                     style={{
// //                                         position: "relative",
// //                                         width: "70px",
// //                                         height: "28px",
// //                                         display: "inline-block",
// //                                         cursor: "pointer",
// //                                         flexShrink: 0
// //                                     }}
// //                                 >
// //                                     <input
// //                                         type="checkbox"
// //                                         checked={isVegSelected}
// //                                         onChange={() =>
// //                                             handleFilterClick(isVegSelected ? "Non-Veg" : "Veg")
// //                                         }
// //                                         style={{ display: "none" }}
// //                                     />

// //                                     {/* Slider */}
// //                                     <span
// //                                         style={{
// //                                             position: "absolute",
// //                                             top: 0,
// //                                             left: 0,
// //                                             right: 0,
// //                                             bottom: 0,
// //                                             backgroundColor: isVegSelected ? "#4CAF50" : "#f44336",
// //                                             borderRadius: "5px",
// //                                             transition: "0.3s",
// //                                         }}
// //                                     ></span>

// //                                     {/* Circle */}
// //                                     <span
// //                                         style={{
// //                                             position: "absolute",
// //                                             height: "16px",
// //                                             width: "16px",
// //                                             left: isVegSelected ? "48px" : "4px",
// //                                             top: "6px",
// //                                             backgroundColor: "white",
// //                                             borderRadius: "50%",
// //                                             transition: "0.3s",
// //                                             boxShadow: "0 0 4px rgba(0,0,0,0.3)",
// //                                         }}
// //                                     ></span>

// //                                     {/* Text */}
// //                                     <span
// //                                         style={{
// //                                             position: "absolute",
// //                                             top: "50%",
// //                                             left: isVegSelected ? "35%" : "60%",
// //                                             transform: "translate(-50%, -50%)",
// //                                             fontSize: "10px",
// //                                             fontWeight: "bold",
// //                                             color: "white",
// //                                             whiteSpace: "nowrap",
// //                                         }}
// //                                     >
// //                                         {isVegSelected ? "Veg" : "Non-Veg"}
// //                                     </span>
// //                                 </label>
// //                             </div>

// //                             {/* Order Type Buttons */}
// //                             <div style={{
// //                                 display: "flex",
// //                                 flexDirection: "row",
// //                                 gap: window.innerWidth <= 1200 ? "5px" : "8px",
// //                                 alignItems: "center",
// //                                 flexShrink: 0
// //                             }}>
// //                                 {["Dine In", "Take Away"].map((type) => (
// //                                     <label
// //                                         key={type}
// //                                         style={{
// //                                             display: "flex",
// //                                             alignItems: "center",
// //                                             gap: window.innerWidth <= 1274 ? "4px" : "6px",
// //                                             padding: window.innerWidth <= 1274 ? "4px 8px" : "6px 10px",
// //                                             borderRadius: "5px",
// //                                             border: `2px solid ${selectedOrderType === type ? "#ccc" : "#ccc"}`,
// //                                             backgroundColor: selectedOrderType === type ? "#d9d9d9" : "#d9d9d9",
// //                                             color: selectedOrderType === type ? "white" : "#000",
// //                                             cursor: "pointer",
// //                                             fontWeight: "bold",
// //                                             fontSize: window.innerWidth <= 1274 ? "12px" : "13px",
// //                                             transition: "all 0.3s ease",
// //                                             width: type === "Dine In" ? (window.innerWidth <= 1200 ?"60px" :window.innerWidth <= 1274 ? "70px" : "85px") : ( window.innerWidth <= 1200 ?"80px" : window.innerWidth <= 1274 ? "85px" : "95px"),
// //                                             textAlign: "center",
// //                                             justifyContent: "center",
// //                                             whiteSpace: "nowrap",
// //                                             flexShrink: 0
// //                                         }}
// //                                     >
// //                                         <input
// //                                             type="radio"
// //                                             name="orderType"
// //                                             value={type}
// //                                             checked={selectedOrderType === type}
// //                                             onChange={async (e) => {
// //                                                 const newOrderType = e.target.value;
// //                                                 console.log("Changing order type to:", newOrderType);
// //                                                 await handleOrderTypeChange(newOrderType);
// //                                             }}
// //                                             style={{
// //                                                 cursor: "pointer",
// //                                                 accentColor: "#b15cd6",
// //                                                 margin: 0,
// //                                                 width: window.innerWidth <= 1200 ? "12px" : "14px",
// //                                                 height: window.innerWidth <= 1200 ? "12px" : "14px"
// //                                             }}
// //                                         />
// //                                         <span style={{
// //                                             whiteSpace: "nowrap",
// //                                             color: selectedOrderType === type ? "#000" : "#000",
// //                                             fontSize: window.innerWidth <= 1200 ? "11px" : "12px"
// //                                         }}>
// //                                             {type}
// //                                         </span>
// //                                     </label>
// //                                 ))}
// //                             </div>
// //                         </div>

// //                         {/* Search Bar Section */}
// //                         <div style={{
// //                             display: "flex",
// //                             alignItems: "center",
// //                             gap: "10px",
// //                             minWidth: window.innerWidth <= 990 ? "100%" : "180px",
// //                             maxWidth: window.innerWidth <= 990 ? "100%" : "280px",
// //                             marginTop: window.innerWidth <= 990 ? "10px" : "0px",
// //                             flexShrink: 1
// //                         }}>
// //                             <div style={{
// //                                 position: "relative",
// //                                 display: "flex",
// //                                 alignItems: "center",
// //                                 width: window.innerWidth<=1200 ? "95%" :  "100%",
// //                                 marginTop:"3px",
// //                             }}>
// //                                 <input
// //                                     type="text"
// //                                     placeholder="Search dishes..."
// //                                     value={searchQuery}
// //                                     onChange={(e) => setSearchQuery(e.target.value)}
// //                                     onKeyPress={(e) => {
// //                                         if (e.key === 'Enter') {
// //                                             handleSearch();
// //                                         }
// //                                     }}
// //                                     style={{
// //                                         width: "100%",
// //                                         padding: window.innerWidth <= 1200 ? "8px 35px 8px 12px" : "8px 35px 8px 12px",
// //                                         borderRadius: "20px",
// //                                         border: "2px solid #b15cd6",
// //                                         fontSize: window.innerWidth <= 1200 ? "12px" : "13px",
// //                                         outline: "none",
// //                                         transition: "all 0.3s ease",
// //                                         backgroundColor: "#fff",
// //                                         height: "35px",
// //                                     }}
// //                                 />
// //                                 <button
// //                                     onClick={handleSearch}
// //                                     style={{
// //                                         position: "absolute",
// //                                         right: "6px",
// //                                         background: "transparent",
// //                                         border: "none",
// //                                         cursor: "pointer",
// //                                         padding: "4px",
// //                                         display: "flex",
// //                                         alignItems: "center",
// //                                         justifyContent: "center"
// //                                     }}
// //                                 >
// //                                     <svg
// //                                         width={window.innerWidth <= 1200 ? "16" : "18"}
// //                                         height={window.innerWidth <= 1200 ? "16" : "18"}
// //                                         viewBox="0 0 24 24"
// //                                         fill="none"
// //                                         stroke="#b15cd6"
// //                                         strokeWidth="2"
// //                                     >
// //                                         <circle cx="11" cy="11" r="8" />
// //                                         <path d="m21 21-4.3-4.3" />
// //                                     </svg>
// //                                 </button>
// //                             </div>
// //                         </div>
// //                     </div>

// //                 </div>
// //             </div>

// //             {/* UPDATED CARD GRID - SMALLER CARDS */}
// //             {/* UPDATED CARD GRID - RESPONSIVE CARDS */}
// //             {/* UPDATED CARD GRID - RESPONSIVE CARDS */}
// //             <div className="offers-containers" style={{
// //                 display: 'grid',
// //                 gridTemplateColumns: 'repeat(auto-fill, minmax(160px, 1fr))',
// //                 gap: '1rem',
// //                 padding: '1rem',
// //                 justifyItems: 'center'
// //             }}>
// //                 {filteredDishes.length > 0 ? (
// //                     filteredDishes.map((item) => (
// //                         <div key={item.dishId} className="offers-cards" style={{
// //                             width: '100%',
// //                             maxWidth: '180px',
// //                             borderRadius: '0.75rem',
// //                             overflow: 'hidden',
// //                             boxShadow: '0 4px 12px rgba(0, 0, 0, 0.1)',
// //                             background: 'white',
// //                             transition: 'all 0.3s ease',
// //                             border: '1px solid #f0f0f0',
// //                             display: 'flex',
// //                             flexDirection: 'column',
// //                             height: '100%'
// //                         }}>
// //                             {/* Image */}
// //                             <div style={{ position: 'relative' }}>
// //                                 {/* <img
// //             src={item.dishImage || "default-image.jpg"}
// //             alt="Dish"
// //             style={{
// //                 width: '100%',
// //                 height: '120px',
// //                 objectFit: 'cover'
// //             }}
// //         /> */}
// //                             </div>

// //                             {/* Content */}
// //                             <div style={{
// //                                 padding: '0.75rem',
// //                                 display: 'flex',
// //                                 flexDirection: 'column',
// //                                 flexGrow: 1
// //                             }}>
// //                                 {/* Title and Veg/Non-Veg Icon */}
// //                                 <div style={{
// //                                     display: "flex",
// //                                     alignItems: "flex-start",
// //                                     justifyContent: "space-between",
// //                                     marginBottom: "0.5rem"
// //                                 }}>
// //                                     <h5 style={{
// //                                         fontSize: "1rem",
// //                                         margin: 0,
// //                                         fontWeight: "600",
// //                                         color: "#333",
// //                                         lineHeight: "1.2",
// //                                         flex: 1,
// //                                         marginRight: "0.5rem"
// //                                     }}>
// //                                         {item.dishName}
// //                                     </h5>

// //                                     {item.tag === "Veg" ? (
// //                                         <div style={{
// //                                             width: "12px",
// //                                             height: "12px",
// //                                             border: "1.5px solid green",
// //                                             borderRadius: "2px",
// //                                             position: "relative",
// //                                             flexShrink: 0,
// //                                             marginTop: "0.25rem"
// //                                         }}>
// //                                             <div style={{
// //                                                 width: "6px",
// //                                                 height: "6px",
// //                                                 backgroundColor: "green",
// //                                                 borderRadius: "50%",
// //                                                 position: "absolute",
// //                                                 top: "50%",
// //                                                 left: "50%",
// //                                                 transform: "translate(-50%, -50%)",
// //                                             }}></div>
// //                                         </div>
// //                                     ) : (
// //                                         <div style={{
// //                                             width: "12px",
// //                                             height: "12px",
// //                                             border: "1.5px solid red",
// //                                             borderRadius: "2px",
// //                                             position: "relative",
// //                                             flexShrink: 0,
// //                                             marginTop: "0.25rem"
// //                                         }}>
// //                                             <div style={{
// //                                                 width: "6px",
// //                                                 height: "6px",
// //                                                 backgroundColor: "red",
// //                                                 borderRadius: "50%",
// //                                                 position: "absolute",
// //                                                 top: "50%",
// //                                                 left: "50%",
// //                                                 transform: "translate(-50%, -50%)",
// //                                             }}></div>
// //                                         </div>
// //                                     )}
// //                                 </div>

// //                                 {/* This spacer pushes the pricing and button to the bottom */}
// //                                 <div style={{ flexGrow: 1 }}></div>

// //                                 {/* Pricing */}
// //                                 <div style={{
// //                                     display: 'flex',
// //                                     alignItems: 'center',
// //                                     gap: '0.5rem',
// //                                     marginBottom: '0.75rem'
// //                                 }}>
// //                                     <span style={{
// //                                         fontSize: '0.8rem',
// //                                         color: 'gray',
// //                                         textDecoration: 'line-through'
// //                                     }}>
// //                                         <i className="fa-solid fa-indian-rupee-sign" style={{ fontSize: '0.7rem' }}></i>
// //                                         {item.price}
// //                                     </span>
// //                                     <span style={{
// //                                         fontSize: '0.9rem',
// //                                         fontWeight: 'bold',
// //                                         color: '#333'
// //                                     }}>
// //                                         <i className="fa-solid fa-indian-rupee-sign" style={{ fontSize: "0.7rem" }}></i>
// //                                         {item.effectivePrice}
// //                                     </span>
// //                                 </div>

// //                                 {/* Add to Cart Button */}
// //                                 <div style={{ textAlign: "center" }}>
// //                                     {cartData.cartItems?.some(ci => ci.dishId === item.dishId) || quantities[item.dishId] > 0 ? (
// //                                         <div style={{
// //                                             display: 'flex',
// //                                             justifyContent: 'space-between',
// //                                             alignItems: 'center',
// //                                             background: '#b15dc6',
// //                                             borderRadius: '1.5rem',
// //                                             padding: '0.25rem 0.5rem',
// //                                             color: 'white'
// //                                         }}>
// //                                             <button
// //                                                 onClick={() => decreaseQuantity(item.dishId)}
// //                                                 style={{
// //                                                     background: 'none',
// //                                                     border: 'none',
// //                                                     color: 'white',
// //                                                     fontSize: '1rem',
// //                                                     cursor: 'pointer',
// //                                                     padding: '0.25rem'
// //                                                 }}
// //                                             >
// //                                                 -
// //                                             </button>
// //                                             <span style={{
// //                                                 fontSize: '0.9rem',
// //                                                 fontWeight: 'bold',
// //                                                 minWidth: '1.5rem',
// //                                                 textAlign: 'center'
// //                                             }}>
// //                                                 {quantities[item.dishId] || 1}
// //                                             </span>
// //                                             <button
// //                                                 onClick={() => increaseQuantity(item.dishId)}
// //                                                 style={{
// //                                                     background: 'none',
// //                                                     border: 'none',
// //                                                     color: 'white',
// //                                                     fontSize: '1rem',
// //                                                     cursor: 'pointer',
// //                                                     padding: '0.25rem'
// //                                                 }}
// //                                             >
// //                                                 +
// //                                             </button>
// //                                         </div>
// //                                     ) : (
// //                                         <button
// //                                             onClick={async () => {
// //                                                 setQuantities(prev => ({ ...prev, [item.dishId]: 1 }));
// //                                                 await addToCart(item, 1);
// //                                             }}
// //                                             style={{
// //                                                 background: "#b15dc6",
// //                                                 color: "#fff",
// //                                                 width: "100%",
// //                                                 borderRadius: "1.5rem",
// //                                                 padding: "0.5rem",
// //                                                 border: "none",
// //                                                 fontSize: "1rem",
// //                                                 fontWeight: "500",
// //                                                 cursor: "pointer"
// //                                             }}
// //                                         >
// //                                             Add To Cart
// //                                         </button>
// //                                     )}
// //                                 </div>
// //                             </div>
// //                         </div>
// //                     ))
// //                 ) : (
// //                     <div style={{
// //                         gridColumn: "1 / -1",
// //                         textAlign: "center",
// //                         padding: "3rem",
// //                         color: "#666",
// //                         fontSize: "1.1rem",
// //                         width: "100%"
// //                     }}>
// //                         {searchQuery ? `No dishes found matching "${searchQuery}"` : "No dishes available"}
// //                     </div>
// //                 )}
// //             </div>



// //             {/* Remove Confirmation Modal */}
// //             <Modal
// //                 isOpen={showRemoveConfirm}
// //                 onRequestClose={cancelRemove}
// //                 contentLabel="Remove Item Confirmation"
// //                 style={{
// //                     overlay: {
// //                         backgroundColor: "rgba(0, 0, 0, 0.5)",
// //                         display: "flex",
// //                         alignItems: "center",
// //                         justifyContent: "center",
// //                         zIndex: 9999
// //                     },
// //                     content: {
// //                         position: "relative",
// //                         top: "auto",
// //                         left: "auto",
// //                         right: "auto",
// //                         bottom: "auto",
// //                         width: "90%",
// //                         maxWidth: "400px",
// //                         margin: "0 auto",
// //                         border: "none",
// //                         borderRadius: "10px",
// //                         padding: "2rem",
// //                         textAlign: "center",
// //                         boxShadow: "0 4px 20px rgba(0, 0, 0, 0.15)"
// //                     }
// //                 }}
// //             >
// //                 <div style={{ textAlign: "center" }}>
// //                     <h3 style={{
// //                         color: "#2d3748",
// //                         marginBottom: "1rem",
// //                         fontSize: "1.3rem"
// //                     }}>
// //                         Remove Item
// //                     </h3>
// //                     <p style={{
// //                         color: "#718096",
// //                         marginBottom: "2rem",
// //                         fontSize: "1rem",
// //                         lineHeight: "1.5"
// //                     }}>
// //                         Are you sure you want to remove<br />
// //                         <strong>"{itemToRemove?.cartItem?.dishName}"</strong><br />
// //                         from your cart?
// //                     </p>
// //                     <div style={{
// //                         display: "flex",
// //                         gap: "1rem",
// //                         justifyContent: "center"
// //                     }}>
// //                         <button
// //                             onClick={cancelRemove}
// //                             style={{
// //                                 padding: "0.75rem 1.5rem",
// //                                 border: "2px solid #e2e8f0",
// //                                 background: "white",
// //                                 color: "#4a5568",
// //                                 borderRadius: "0.5rem",
// //                                 cursor: "pointer",
// //                                 fontWeight: "600",
// //                                 fontSize: "1rem",
// //                                 transition: "all 0.2s ease"
// //                             }}
// //                             onMouseOver={(e) => {
// //                                 e.target.style.borderColor = "#b15cd6";
// //                                 e.target.style.color = "#b15cd6";
// //                             }}
// //                             onMouseOut={(e) => {
// //                                 e.target.style.borderColor = "#e2e8f0";
// //                                 e.target.style.color = "#4a5568";
// //                             }}
// //                         >
// //                             Cancel
// //                         </button>
// //                         <button
// //                             onClick={confirmRemove}
// //                             style={{
// //                                 padding: "0.75rem 1.5rem",
// //                                 border: "none",
// //                                 background: "#e53e3e",
// //                                 color: "white",
// //                                 borderRadius: "0.5rem",
// //                                 cursor: "pointer",
// //                                 fontWeight: "600",
// //                                 fontSize: "1rem",
// //                                 transition: "all 0.2s ease"
// //                             }}
// //                             onMouseOver={(e) => {
// //                                 e.target.style.background = "#c53030";
// //                             }}
// //                             onMouseOut={(e) => {
// //                                 e.target.style.background = "#e53e3e";
// //                             }}
// //                         >
// //                             Remove
// //                         </button>
// //                     </div>
// //                 </div>
// //             </Modal>
// //             <style>
// //                 {`
// //         /* Existing styles... */

// //         /* Responsive Grid for Cards */
// //         .offers-containers {
// //             display: grid;
// //             grid-template-columns: repeat(auto-fill, minmax(150px, 1fr));
// //             gap: 1rem;
// //             padding: 1rem;
// //             justify-items: center;
// //         }

// //         .offers-cards {
// //             width: 100%;
// //             max-width: 180px;
// //             border-radius: 0.75rem;
// //             overflow: hidden;
// //             box-shadow: 0 4px 12px rgba(0, 0, 0, 0.1);
// //             background: white;
// //             transition: all 0.3s ease;
// //             border: 1px solid #f0f0f0;
// //         }

// //         .offers-cards:hover {
// //             transform: translateY(-4px);
// //             box-shadow: 0 8px 20px rgba(0, 0, 0, 0.15);
// //         }

// //         /* Mobile First: 1-2 cards */
// //         @media (max-width: 479px) {
// //             .offers-containers {
// //                 grid-template-columns: repeat(auto-fit, minmax(140px, 1fr));
// //                 gap: 0.75rem;
// //                 padding: 0.75rem;
// //             }
// //             .offers-cards {
// //                 max-width: 160px;
// //             }
// //         }

// //         /* Small Tablets: 2 cards */
// //         @media (min-width: 480px) and (max-width: 639px) {
// //             .offers-containers {
// //                 grid-template-columns: repeat(2, 1fr);
// //                 gap: 1rem;
// //             }
// //             .offers-cards {
// //                 max-width: 100%;
// //             }
// //         }

// //         /* Tablets: 2-3 cards */
// //         @media (min-width: 640px) and (max-width: 799px) {
// //             .offers-containers {
// //                 grid-template-columns: repeat(2, 1fr);
// //                 gap: 1.25rem;
// //             }
// //             .offers-cards {
// //                 max-width: 100%;
// //             }
// //         }

// //         /* Desktop: 3 cards from 800px */
// //         @media (min-width: 800px) and (max-width: 1023px) {
// //             .offers-containers {
// //                 grid-template-columns: repeat(3, 1fr);
// //                 gap: 1.5rem;
// //                 padding: 1.5rem;
// //             }
// //             .offers-cards {
// //                 max-width: 100%;
// //             }
// //         }

// //         /* Large Desktop: 4+ cards */
// //         @media (min-width: 1024px) and (max-width: 1279px) {
// //             .offers-containers {
// //                 grid-template-columns: repeat(auto-fit, minmax(180px, 1fr));
// //                 gap: 1.5rem;
// //             }
// //         }

// //         @media (min-width: 1280px) {
// //             .offers-containers {
// //                 grid-template-columns: repeat(auto-fit, minmax(200px, 1fr));
// //                 gap: 2rem;
// //             }
// //         }

// //         /* Card content adjustments for better responsiveness */
// //         @media (max-width: 639px) {
// //             .offers-cards {
// //                 padding: 0.5rem;
// //             }
// //             .card-title {
// //                 font-size: 0.8rem !important;
// //             }
// //         }

// //         @media (min-width: 800px) and (max-width: 1023px) {
// //             .offers-cards {
// //                 padding: 0.75rem;
// //             }
// //         }

// //         /* Existing other styles... */
// //     `}
// //             </style>

// //         </div>
// //     );
// // };

// // export default MenuItems;










import React, { useEffect, useState } from 'react';
import './menuiteams.css';

import Modal from 'react-modal';
import { ShoppingCart } from '@mui/icons-material';
import { useNavigate } from 'react-router-dom';
import axios from 'axios';
import { FormControlLabel, Switch, Typography } from "@mui/material";

Modal.setAppElement('#root');
const MenuItems = ({ parentId }) => {
    const [dishes, setDishes] = useState([]);
    const [filteredDishes, setFilteredDishes] = useState([]);
    const [quantities, setQuantities] = useState({});
    const [loading, setLoading] = useState(true);
    const [error, setError] = useState(null);
    const [isVegSelected, setIsVegSelected] = useState(false);
    const [isNonVegSelected, setIsNonVegSelected] = useState(false);
    const [isModalOpen, setIsModalOpen] = useState(false);
    const [cartData, setCartData] = useState({ cartItems: [] });
    const [isHovered, setIsHovered] = useState(false);
    const navigate = useNavigate();
    const [selectedOrderType, setSelectedOrderType] = useState("");
    const [refresh, setRefresh] = useState(false);
    const [activeTab, setActiveTab] = useState(" ");
    const [showRemoveConfirm, setShowRemoveConfirm] = useState(false);
    const [itemToRemove, setItemToRemove] = useState(null);
    const [grandTotal, setGrandTotal] = useState(0);
    // Add this with other state declarations
    const [searchQuery, setSearchQuery] = useState("");
    // Add these subscription-related states
    const [subscriptionPlan, setSubscriptionPlan] = useState("basic");
    const [showItemsUpdateButton, setShowItemsUpdateButton] = useState(false);
    const [showItemsUpdate, setShowItemsUpdate] = useState(false);
    // Add this useEffect near your other useEffects
    useEffect(() => {
        // Get subscription plan from localStorage
        const getSubscriptionPlan = () => {
            try {
                const planData = localStorage.getItem("planTypes");
                if (planData) {
                    let plans = JSON.parse(planData);

                    // Ensure it's always an array
                    if (!Array.isArray(plans)) {
                        plans = [plans];
                    }

                    // Normalize to lowercase for comparison
                    const normalizedPlans = plans.map(p => p.toLowerCase());

                    // Check for available plans
                    let selectedPlan = "basic"; // default
                    if (normalizedPlans.includes("premium")) selectedPlan = "premium";
                    else if (normalizedPlans.includes("standard")) selectedPlan = "standard";
                    else if (normalizedPlans.includes("basic")) selectedPlan = "basic";

                    console.log("📦 MenuItems Subscription plan detected:", selectedPlan);
                    setSubscriptionPlan(selectedPlan);
                    setShowItemsUpdateButton(selectedPlan === "standard" || selectedPlan === "premium");
                } else {
                    console.warn("⚠️ No subscription plan found in localStorage");
                    setSubscriptionPlan("basic");
                    setShowItemsUpdateButton(false);
                }
            } catch (error) {
                console.error("Error parsing subscription plan:", error);
                setSubscriptionPlan("basic");
                setShowItemsUpdateButton(false);
            }
        };

        getSubscriptionPlan();
    }, []);
    const applyCurrentFilters = () => {
        let filtered = dishes;

        if (isVegSelected) {
            filtered = filtered.filter(dish => dish.tag === 'Veg');
        } else if (isNonVegSelected) {
            filtered = filtered.filter(dish => dish.tag === 'Non_Veg');
        }

        setFilteredDishes(filtered);
    };
    const handleSearch = () => {
        if (!searchQuery.trim()) {
            // If search is empty, show all items based on current filters
            applyCurrentFilters();
            return;
        }

        const searchTerm = searchQuery.toLowerCase().trim();

        // Filter dishes based on search term
        const searchResults = dishes.filter(dish =>
            dish.dishName.toLowerCase().includes(searchTerm)
        );

        if (searchResults.length > 0) {
            setFilteredDishes(searchResults);
        } else {
            setFilteredDishes([]);
        }
    };
    useEffect(() => {
        handleSearch();
    }, [searchQuery, dishes]);

    useEffect(() => {
        const handleCartUpdate = () => {
            setRefresh(prev => prev + 1);
        };

        window.addEventListener('cartUpdated', handleCartUpdate);
        return () => {
            window.removeEventListener('cartUpdated', handleCartUpdate);
        };
    }, []);

    const handleFilterClick = (type) => {
        if (type === 'Veg') {
            setIsVegSelected(true);
            setIsNonVegSelected(false);
            applyFilter('Veg');
        } else if (type === 'Non-Veg') {
            setIsVegSelected(false);
            setIsNonVegSelected(true);
            applyFilter('Non_Veg');
        } else {
            // Show all
            setIsVegSelected(false);
            setIsNonVegSelected(false);
            setFilteredDishes(dishes);
        }
    };

    useEffect(() => {
        if (dishes.length > 0) {
            if (isVegSelected) {
                applyFilter('Veg');
            } else if (isNonVegSelected) {
                applyFilter('Non_Veg');
            } else {
                setFilteredDishes(dishes);
            }
        }
    }, [dishes, isVegSelected, isNonVegSelected]);

    const authToken = localStorage.getItem("authToken");
    const vendorId = localStorage.getItem("vendorId");

    const triggerCartRefresh = () => {
        const event = new CustomEvent('cartUpdated');
        window.dispatchEvent(event);
    }

    // SINGLE fetchCartData function - remove the duplicate one below
    const fetchCartData = async () => {
        const authToken = localStorage.getItem("authToken");
        const vendorId = localStorage.getItem("vendorId");

        if (!authToken || !vendorId) return;

        try {
            const response = await axios.get(
                `https://backend.maamaas.com/food/api/cart/vendor/${vendorId}`,
                { headers: { Authorization: `Bearer ${authToken}` } }
            );
            setCartData(response.data);
            setGrandTotal(response.data.grandTotal || 0); // Add this line

            const initialQuantities = {};
            if (response.data.cartItems) {
                response.data.cartItems.forEach(item => {
                    initialQuantities[item.dishId] = item.quantity;
                });
            }
            setQuantities(initialQuantities);
        } catch (err) {
            console.error("Error fetching cart:", err);
        }
    };

    const increaseQuantity = async (dishId) => {
        const token = localStorage.getItem("authToken");
        const vendorId = localStorage.getItem("vendorId");
        if (!token || !vendorId) return alert("Auth token or vendorId missing");

        if (!cartData || !cartData.cartItems) {
            alert("Cart is empty or not loaded yet.");
            return;
        }

        const cartItem = cartData.cartItems.find(item => item.dishId === dishId);
        if (!cartItem) {
            alert("Item not found in cart. Please add it first.");
            return;
        }

        const newQty = (quantities[dishId] || 0) + 1;

        const apiUrl = `https://backend.maamaas.com/food/api/cart/update/cart/${vendorId}/${cartData.cartId}?dishId=${dishId}&quantity=${newQty}`;

        console.log("API URL:", apiUrl);

        try {
            const response = await axios.put(apiUrl, null, {
                headers: { Authorization: `Bearer ${token}` }
            });

            console.log("API Response:", response.data);

            // Update local state immediately
            setQuantities(prev => ({ ...prev, [dishId]: newQty }));
            setCartData(prev => ({
                ...prev,
                cartItems: prev.cartItems.map(item =>
                    item.dishId === dishId ? { ...item, quantity: newQty } : item
                )
            }));

            // Refresh cart data to get updated totals
            await fetchCartData();

            setIsModalOpen(true);
            triggerCartRefresh();
            setTimeout(() => {
                if (!isHovered) setIsModalOpen(false);
            }, 2000);
        } catch (err) {
            console.error("API Error:", err.response ? err.response.data : err);
            alert("Unable to update quantity for dishId: " + dishId);
        }
    };

    const decreaseQuantity = async (dishId) => {
        const token = localStorage.getItem("authToken");
        const vendorId = localStorage.getItem("vendorId");
        const currentQty = quantities[dishId] || 0;
        if (currentQty === 0) return;

        if (!cartData || !cartData.cartItems) {
            alert("Cart is empty or not loaded yet.");
            return;
        }

        const cartItem = cartData.cartItems.find(item => item.dishId === dishId);
        if (!cartItem) return alert("Item not found");

        const newQty = currentQty - 1;

        // If quantity becomes 0, show custom confirmation
        if (newQty === 0) {
            setItemToRemove({ dishId, cartItem });
            setShowRemoveConfirm(true);
            return;
        }

        // Continue with normal decrease
        await updateQuantity(dishId, newQty);
    };
    const updateQuantity = async (dishId, newQty) => {
        const token = localStorage.getItem("authToken");
        const vendorId = localStorage.getItem("vendorId");

        const apiUrl = `https://backend.maamaas.com/food/api/cart/update/cart/${vendorId}/${cartData.cartId}?dishId=${dishId}&quantity=${newQty}`;

        try {
            const response = await axios.put(apiUrl, null, {
                headers: { Authorization: `Bearer ${token}` }
            });

            // Update local state immediately
            setQuantities(prev => ({ ...prev, [dishId]: newQty > 0 ? newQty : 0 }));
            setCartData(prev => ({
                ...prev,
                cartItems: newQty > 0
                    ? prev.cartItems.map(item =>
                        item.dishId === dishId ? { ...item, quantity: newQty } : item
                    )
                    : prev.cartItems.filter(item => item.dishId !== dishId)
            }));

            // Refresh cart data to get updated totals
            await fetchCartData();

            setIsModalOpen(true);
            triggerCartRefresh();
            setTimeout(() => {
                if (!isHovered) setIsModalOpen(false);
            }, 2000);
        } catch (err) {
            console.error("API Error:", err.response ? err.response.data : err);
            alert("Unable to update quantity for dishId: " + dishId);
        }
    };

    const confirmRemove = async () => {
        if (itemToRemove) {
            await updateQuantity(itemToRemove.dishId, 0);
            setShowRemoveConfirm(false);
            setItemToRemove(null);
        }
    };

    const cancelRemove = () => {
        setShowRemoveConfirm(false);
        setItemToRemove(null);
    };

    

    useEffect(() => {
        fetchCartData();
    }, [authToken, vendorId, refresh]); // Add refresh to dependencies

    // Order Type Change Function
    const handleOrderTypeChange = async (type) => {
        const vendorId = localStorage.getItem("vendorId");
        const token = localStorage.getItem("authToken");

        if (!vendorId || !token) {
            alert("Vendor not logged in!");
            return;
        }

        try {
            const orderTypeValue = type === "Dine In" ? "DINE_IN" : "TAKEAWAY";

            console.log("Updating order type:", {
                vendorId,
                orderType: orderTypeValue,
                currentCartId: cartData.cartId
            });

            await axios.put(
                `https://backend.maamaas.com/food/api/cart/update/orderType/${vendorId}?orderType=${orderTypeValue}`,
                {},
                { headers: { Authorization: `Bearer ${token}` } }
            );

            // Update local state
            setSelectedOrderType(type);

            // Refresh cart data to get updated prices/charges
            await fetchCartData();

            // Trigger cart refresh for sidebar and navbar
            triggerCartRefresh();

            console.log("Order type updated successfully to:", type);

        } catch (error) {
            console.error("❌ Error updating order type:", error);
            alert("Failed to update order type. Please try again.");
        }
    };

    const addToCart = async (item, quantity = 1) => {
        const vendorId = localStorage.getItem("vendorId");
        const token = localStorage.getItem("authToken");

        const formatOrderType = (type) => {
            if (!type) return "DINE_IN";
            const cleaned = type.toLowerCase().replace(/\s+/g, "");
            return cleaned === "dinein" ? "DINE_IN" : "TAKEAWAY";
        };

        const orderType = formatOrderType(selectedOrderType);

        console.log("Adding to cart with order type:", orderType);

        const apiUrl = `https://backend.maamaas.com/food/api/cart/add/vendor/${vendorId}?orderType=${orderType}`;
        const data = { dishId: item.dishId, quantity };

        try {
            const response = await axios.post(apiUrl, data, {
                headers: {
                    "Content-Type": "application/json",
                    "Authorization": `Bearer ${token}`,
                },
            });

            if (response.status === 200) {
                await fetchCartData();
                triggerCartRefresh();
                setIsModalOpen(true);
                setTimeout(() => {
                    if (!isHovered) setIsModalOpen(false);
                }, 2000);
            } else {
                alert("Failed to add item to cart");
            }
        } catch (error) {
            console.error("Please Complete Billing Setup", error);
            alert("Please Complete Billing Setup");
        }
    };

    useEffect(() => {
        const fetchData = async () => {
            const vendorId = localStorage.getItem("vendorId");
            const token = localStorage.getItem("authToken");

            if (!vendorId) {
                console.warn("⚠️ vendorId not found in localStorage");
                setError(new Error("vendorId missing"));
                setLoading(false);
                return;
            }

            if (!token) {
                console.warn("⚠️ authToken not found in localStorage");
                setError(new Error("authToken missing"));
                setLoading(false);
                return;
            }

            try {
                const response = await fetch(
                    `https://backend.maamaas.com/food/api/dish/getbyvendor/${vendorId}`,
                    {
                        headers: {
                            'Authorization': `Bearer ${token}`,
                            'Content-Type': 'application/json',
                            'Accept': 'application/json',
                        },
                    }
                );

                if (!response.ok) {
                    throw new Error(`HTTP error! status: ${response.status}`);
                }

                const data = await response.json();
                const dishData = Array.isArray(data) ? data : data.data || [];
                const validDishData = dishData.filter(item => item !== null && item !== undefined);

                const filteredData = validDishData.filter(item => {
                    const parentCheck = parentId ? Number(item.parentId) === Number(parentId) : Number(item.parentId) !== 0;
                    const statusCheck = item.menuStatus === "Enable";
                    const quantityCheck = Number(item.balanceQuantity) > 0;
                    return parentCheck && statusCheck && quantityCheck;
                });

                setDishes(filteredData);
            } catch (error) {
                console.error('Error fetching data:', error);
                setError(error);
            } finally {
                setLoading(false);
            }
        };

        fetchData();
    }, [parentId]);
    // Global search hotkey functionality
    useEffect(() => {
        const handleGlobalKeyDown = (e) => {
            // Ignore if user is already typing in an input or textarea
            const isTypingInInput =
                e.target.tagName === 'INPUT' ||
                e.target.tagName === 'TEXTAREA' ||
                e.target.isContentEditable;

            // Focus search when '/' is pressed (like most websites)
            if (e.key === '/' && !isTypingInInput) {
                e.preventDefault();
                const searchInput = document.querySelector('input[type="text"][placeholder*="Search"]');
                if (searchInput) {
                    searchInput.focus();
                    searchInput.select();
                }
            }

            // Handle any character key when search is focused
            const searchInput = document.querySelector('input[type="text"][placeholder*="Search"]:focus');
            if (searchInput && !isTypingInInput) {
                // Backspace handling
                if (e.key === 'Backspace') {
                    e.preventDefault();
                    setSearchQuery(prev => prev.slice(0, -1));
                }
                // Clear search with Escape
                else if (e.key === 'Escape') {
                    e.preventDefault();
                    searchInput.blur();
                    setSearchQuery("");
                }
            }

            // Special case: start typing anywhere to search (except when already typing)
            if (!isTypingInInput &&
                e.key.length === 1 &&
                !e.ctrlKey &&
                !e.metaKey &&
                !e.altKey &&
                e.key !== ' ') {

                // Get search input
                const searchInput = document.querySelector('input[type="text"][placeholder*="Search"]');

                if (searchInput) {
                    // If search is not focused, focus it
                    if (document.activeElement !== searchInput) {
                        e.preventDefault();
                        searchInput.focus();
                        // Set the typed character as the search query
                        setSearchQuery(e.key);
                    }
                }
            }
        };

        window.addEventListener('keydown', handleGlobalKeyDown);

        return () => {
            window.removeEventListener('keydown', handleGlobalKeyDown);
        };
    }, [searchQuery]);

    const handleViewCartClick = () => {
        navigate('/foodcart');
    };

    if (loading) {
        return <div>Loading...</div>;
    }

    if (error) {
        return <div>Error loading dishes: {error.message}</div>;
    }
    // Add these functions after other state functions

    // Search function


    // Auto-search when searchQuery changes


    // Update applyCurrentFilters function

    const applyFilter = (filterType) => {
        let filtered = dishes;

        if (filterType === 'Veg') {
            filtered = dishes.filter(dish => dish.tag === 'Veg');
        } else if (filterType === 'Non_Veg') {
            filtered = dishes.filter(dish => dish.tag === 'Non_Veg');
        }

        // Apply search filter if there's a search query
        if (searchQuery.trim()) {
            const searchTerm = searchQuery.toLowerCase().trim();
            filtered = filtered.filter(dish =>
                dish.dishName.toLowerCase().includes(searchTerm)
            );
        }

        setFilteredDishes(filtered);
    };

    return (
        <div style={{ marginTop: '6rem' }} className='menuiteams-data'>
            {/* Header buttons (keep your existing header) */}
            <div style={{
                display: "flex",
                flexWrap: "wrap",
                gap: "1rem",
                marginBottom: "1rem",
                justifyContent: "space-between",
                alignItems: "center",
                padding: "0rem"
            }}>
                <style>
                    {`
                        @media (max-width: 768px) {
                            .offers-containers {
                                grid-template-columns: repeat(2, 1fr) !important;
                                gap: 15px !important;
                            }
                            .offers-cards {
                                width: 100% !important;
                                max-width: 100% !important;
                            }
                            .responsive-button-group {
                                flex-direction: column !important;
                                align-items: center !important;
                                width:90vw !important;
                            }
                            .responsive-button {
                                width: 25% !important;
                                text-align: center;
                            }
                            .custom-switch-wrapper {
                                margin-top: 10px;
                           left: "-20px"
                            }
                        }
 @media (min-width: 980px) {
                               .custom-switch-wrapper {

                           margin-left: -20px !important;
                            }
                    }
 @media (min-width: 980px) {
                    .add-iteams-data{
                    margin-left:8vw!important;
                    }
                    .dst{
                    margin-left:-11px !important;
                    }
                    }
                        @media (max-width: 480px) {
                            .offers-containers {
                                grid-template-columns: 1fr !important;
                            }
                            .offers-cards {
                                margin: 0 auto !important;
                            }
                            .card-body {
                                padding: 10px !important;
                            }
                            .card-title {
                                font-size: 18px !important;
                            }
                        }

                        @media (max-width: 320px) {
                            .offers-cards {
                                width: 95% !important;
                            }
                            .card-body {
                                padding: 8px !important;
                            }
                            .card-title {
                                font-size: 16px !important;
                            }
                        }

                        .custom-switch {
                            position: relative;
                            display: inline-block;
                            width: 100px;
                            height: 35px;
                        }

                        .custom-switch input {
                            opacity: 0;
                            width: 0;
                            height: 0;
                        }

                        .custom-slideryy {
                            position: absolute;
                            cursor: pointer;
                            transition: 0.4s;
                            font-weight: bold;
                            font-size: 14px;
                            color: #000;
                            textAlign: "center",
                            lineHeight: 35px;
                            width: 100px;
                            height: 40px;
                            borderRadius: 5px;
                            backgroundColor: rgb(217, 217, 217);
                        }

                        .custom-slideryy::before {
                            content: "";
                            position: absolute;
                            height: 16px;
                            width: 16px;
                            left: 8px;
                            top: 13px;
                            backgroundColor: #000;
                            transition: 0.4s;
                            borderRadius: 50%;
                        }

                        .custom-slideryy.veg::before {
                            backgroundColor: green;
                        }

                        .custom-slideryy.non-veg::before {
                            backgroundColor: red;
                        }

                        .custom-switch input:checked + .custom-slideryy::before {
                            transform: translateX(60px);
                        }
                            @media (max-width: 768px) {
    .offers-containers {
        grid-template-columns: repeat(2, 1fr) !important;
        gap: 15px !important;
    }
    .offers-cards {
        width: 100% !important;
        max-width: 100% !important;
    }
    .responsive-button-group {
        flex-direction: column !important;
        align-items: center !important;
        width:90vw !important;
    }
    .additembutton {
        // width: 45% !important;
        text-align: center;
        padding: 6px 0px !important;
    }
    .itemsupdatebutton {
        width: 45% !important;
        text-align: center;
    }
    .custom-switch-wrapper {
        margin-top: 10px;
        left: "-20px"
    }
}
                    `}
                </style>

                <div
                    className="responsive-button-group menu-responsive-buttons-code"
                    style={{
                        display: "flex",
                        flexDirection: "column",
                        justifyContent: "start",
                        alignItems: window.innerWidth < 768 ? "flex-start" : "start",
                        marginLeft: window.innerWidth < 768 ? "0" : "15px",
                        width: "100%",
                        gap: "10px",
                        marginTop: window.innerWidth >= 768 && window.innerWidth < 769 ? "25px" : window.innerWidth < 768 ? "-25" : "-17px",
                        
                    }}
                >
                    {/* Top Row - Menu and Add Items (always in one line) */}
                    <div style={{
                        display: "flex",
                        flexDirection: "row",
                        gap: window.innerWidth < 768 ? "8px" : "10px",
                        alignItems: "center",
                        marginTop: window.innerWidth < 768 ? "0" : "10px",
                        marginBottom: window.innerWidth < 768 ? "-5px" : "-15px",
                        width: "100%",
                    }}>
                        <div
                            className="responsive-button"
                            style={{
                                padding: window.innerWidth < 768 ? "6px 12px" : "6px 13px",
                                border: "none",
                                backgroundColor: "#b15cd6",
                                color: "#fff",
                                borderRadius: "5px",
                                cursor: "pointer",
                                transition: "all 0.3s",
                                fontWeight: "bold",
                                fontSize: window.innerWidth < 768 ? "13px" : "inherit",
                                whiteSpace: "nowrap",
                            }}
                        >
                            Menu
                        </div>

                        <div
                            className="additembutton"
                            style={{
                                padding: window.innerWidth < 768 ? "6px 12px" : "6px 13px",
                                border: "none",
                                backgroundColor: activeTab === "first" ? "#b15cd6" : "#d9d9d9",
                                color: activeTab === "first" ? "white" : "#000",
                                borderRadius: "5px",
                                cursor: "pointer",
                                transition: "all 0.3s",
                                fontWeight: "bold",
                                fontSize: window.innerWidth < 768 ? "13px" : "inherit",
                                boxShadow: activeTab === "first" ? "0 2px 5px rgba(0,0,0,0.2)" : "none",
                                width: window.innerWidth < 768 ? "100px" : window.innerWidth <= 558 ? "100px" : "auto",
                                textAlign: "center",
                                whiteSpace: "nowrap",
                            }}
                            onClick={() => navigate("/foodandbeveragesMenu")}
                        >
                            Add Items
                        </div>
                    </div>

                    {/* Bottom Section - Controls */}
                    <div style={{
                        display: "flex",
                        flexDirection: window.innerWidth < 400 ? "column" : window.innerWidth < 768 ? "row" : window.innerWidth <= 990 ? "column" : "row",
                        gap: window.innerWidth < 400 ? "10px" : window.innerWidth < 768 ? "10px" : window.innerWidth <= 990 ? "15px" : "10px",
                        alignItems: window.innerWidth < 400 ? "flex-start" : "center",
                        justifyContent: "space-between",
                        width: "100%",
                        flexWrap: window.innerWidth < 400 ? "nowrap" : window.innerWidth <= 1200 ? " " : "wrap"
                    }}>
                        {/* Toggle and Order Type Section */}
                        <div style={{
                            display: "flex",
                            flexDirection: "row",
                            gap: window.innerWidth < 400 ? "8px" : window.innerWidth < 768 ? "10px" : window.innerWidth <= 1200 ? "10px" : "15px",
                            alignItems: "center",
                            flexWrap: "nowrap",
                            flexShrink: 0,
                            width: window.innerWidth < 400 ? "100%" : "auto",
                        }}>
                            {/* Veg/Non-Veg Toggle */}
                            <div
                                className="toggle-container"
                                style={{
                                    position: "relative",
                                    display: "flex",
                                    justifyContent: "center",
                                    alignItems: "center",
                                    flexShrink: 0
                                }}
                            >
                                <label
                                    className="veg-toggle"
                                    style={{
                                        position: "relative",
                                        width: window.innerWidth < 400 ? "65px" : window.innerWidth < 768 ? "68px" : "70px",
                                        height: window.innerWidth < 400 ? "26px" : window.innerWidth < 768 ? "27px" : "28px",
                                        display: "inline-block",
                                        cursor: "pointer",
                                        flexShrink: 0,
                                        marginTop:"5px",
                                    }}
                                >
                                    <input
                                        type="checkbox"
                                        checked={isVegSelected}
                                        onChange={() =>
                                            handleFilterClick(isVegSelected ? "Non-Veg" : "Veg")
                                        }
                                        style={{ display: "none" }}
                                    />

                                    {/* Slider */}
                                    <span
                                        style={{
                                            position: "absolute",
                                            top: 0,
                                            left: 0,
                                            right: 0,
                                            bottom: 0,
                                            backgroundColor: isVegSelected ? "#4CAF50" : "#f44336",
                                            borderRadius: "5px",
                                            transition: "0.3s",
                                        }}
                                    ></span>

                                    {/* Circle */}
                                    <span
                                        style={{
                                            position: "absolute",
                                            height: window.innerWidth < 400 ? "14px" : "16px",
                                            width: window.innerWidth < 400 ? "14px" : "16px",
                                            left: isVegSelected ? "46px" : "4px",
                                            top: window.innerWidth < 400 ? "6px" : "6px",
                                            backgroundColor: "white",
                                            borderRadius: "50%",
                                            transition: "0.3s",
                                            boxShadow: "0 0 4px rgba(0,0,0,0.3)",
                                        }}
                                    ></span>

                                    {/* Text */}
                                    <span
                                        style={{
                                            position: "absolute",
                                            top: "50%",
                                            left: isVegSelected ? "35%" : "60%",
                                            transform: "translate(-50%, -50%)",
                                            fontSize: window.innerWidth < 400 ? "9px" : "10px",
                                            fontWeight: "bold",
                                            color: "white",
                                            whiteSpace: "nowrap",
                                        }}
                                    >
                                        {isVegSelected ? "Veg" : "Non-Veg"}
                                    </span>
                                </label>
                            </div>

                            {/* Order Type Buttons */}
                            <div style={{
                                display: "flex",
                                flexDirection: "row",
                                gap: window.innerWidth < 400 ? "5px" : window.innerWidth < 768 ? "5px" : window.innerWidth <= 1200 ? "5px" : "8px",
                                alignItems: "center",
                                flexShrink: 0
                            }}>
                                {["Dine In", "Take Away"].map((type) => (
                                    <label
                                        key={type}
                                        style={{
                                            display: "flex",
                                            alignItems: "center",
                                            gap: window.innerWidth < 400 ? "4px" : window.innerWidth < 768 ? "4px" : window.innerWidth <= 1274 ? "4px" : "6px",
                                            padding: window.innerWidth < 400 ? "4px 6px" : window.innerWidth < 768 ? "4px 8px" : window.innerWidth <= 1274 ? "4px 8px" : "6px 10px",
                                            borderRadius: "5px",
                                            border: `2px solid ${selectedOrderType === type ? "#ccc" : "#ccc"}`,
                                            backgroundColor: selectedOrderType === type ? "#d9d9d9" : "#d9d9d9",
                                            color: selectedOrderType === type ? "white" : "#000",
                                            cursor: "pointer",
                                            fontWeight: "bold",
                                            fontSize: window.innerWidth < 400 ? "11px" : window.innerWidth < 768 ? "11px" : window.innerWidth <= 1274 ? "12px" : "13px",
                                            transition: "all 0.3s ease",
                                            width: type === "Dine In"
                                                ? (window.innerWidth < 400 ? "60px" : window.innerWidth < 768 ? "65px" : window.innerWidth <= 1200 ? "60px" : window.innerWidth <= 1274 ? "70px" : "85px")
                                                : (window.innerWidth < 400 ? "75px" : window.innerWidth < 768 ? "80px" : window.innerWidth <= 1200 ? "80px" : window.innerWidth <= 1274 ? "85px" : "95px"),
                                            textAlign: "center",
                                            justifyContent: "center",
                                            whiteSpace: "nowrap",
                                            flexShrink: 0,
                                            marginTop:"5px",
                                        }}
                                    >
                                        <input
                                            type="radio"
                                            name="orderType"
                                            value={type}
                                            checked={selectedOrderType === type}
                                            onChange={async (e) => {
                                                const newOrderType = e.target.value;
                                                console.log("Changing order type to:", newOrderType);
                                                await handleOrderTypeChange(newOrderType);
                                            }}
                                            style={{
                                                cursor: "pointer",
                                                accentColor: "#b15cd6",
                                                margin: 0,
                                                width: window.innerWidth < 400 ? "11px" : window.innerWidth < 768 ? "12px" : window.innerWidth <= 1200 ? "12px" : "14px",
                                                height: window.innerWidth < 400 ? "11px" : window.innerWidth < 768 ? "12px" : window.innerWidth <= 1200 ? "12px" : "14px"
                                            }}
                                        />
                                        <span style={{
                                            whiteSpace: "nowrap",
                                            color: selectedOrderType === type ? "#000" : "#000",
                                            fontSize: window.innerWidth < 400 ? "10px" : window.innerWidth < 768 ? "11px" : window.innerWidth <= 1200 ? "11px" : "12px"
                                        }}>
                                            {type}
                                        </span>
                                    </label>
                                ))}
                            </div>
                        </div>

                        {/* Search Bar Section */}
                        <div style={{
                            display: "flex",
                            alignItems: "center",
                            gap: "10px",
                            minWidth: window.innerWidth < 400 ? "100%" : window.innerWidth < 768 ? "auto" : window.innerWidth <= 990 ? "100%" : "180px",
                            maxWidth: window.innerWidth < 400 ? "100%" : window.innerWidth < 768 ? "100%" : window.innerWidth <= 990 ? "100%" : "280px",
                            marginTop: window.innerWidth < 400 ? "0" : window.innerWidth < 768 ? "0" : window.innerWidth <= 990 ? "10px" : "0px",
                            flexShrink: 1,
                            width: window.innerWidth < 400 ? "100%" : "auto",
                        }}>
                            <div style={{
                                position: "relative",
                                display: "flex",
                                alignItems: "center",
                                width: window.innerWidth < 400 ? "100%" : window.innerWidth < 768 ? "95%" : window.innerWidth <= 1200 ? "95%" : "100%",
                                marginTop: window.innerWidth < 400 ? "0" : "3px",
                            }}>
                                <input
                                    type="text"
                                    placeholder="Search dishes... "
                                    value={searchQuery}
                                    onChange={(e) => setSearchQuery(e.target.value)}
                                    onKeyPress={(e) => {
                                        if (e.key === 'Enter') {
                                            handleSearch();
                                        }
                                    }}
                                    style={{
                                        width: "100%",
                                        padding: window.innerWidth < 400 ? "6px 30px 6px 10px" : window.innerWidth < 768 ? "7px 32px 7px 10px" : window.innerWidth <= 1200 ? "8px 35px 8px 12px" : "8px 35px 8px 12px",
                                        borderRadius: "20px",
                                        border: "2px solid #b15cd6",
                                        fontSize: window.innerWidth < 400 ? "12px" : window.innerWidth < 768 ? "12px" : window.innerWidth <= 1200 ? "12px" : "13px",
                                        outline: "none",
                                        transition: "all 0.3s ease",
                                        backgroundColor: "#fff",
                                        height: window.innerWidth < 400 ? "32px" : window.innerWidth < 768 ? "33px" : "35px",
                                    }}
                                />
                                <button
                                    onClick={handleSearch}
                                    style={{
                                        position: "absolute",
                                        right: window.innerWidth < 400 ? "5px" : "6px",
                                        background: "transparent",
                                        border: "none",
                                        cursor: "pointer",
                                        padding: "4px",
                                        display: "flex",
                                        alignItems: "center",
                                        justifyContent: "center"
                                    }}
                                >
                                    <svg
                                        width={window.innerWidth < 400 ? "14" : window.innerWidth < 768 ? "15" : window.innerWidth <= 1200 ? "16" : "18"}
                                        height={window.innerWidth < 400 ? "14" : window.innerWidth < 768 ? "15" : window.innerWidth <= 1200 ? "16" : "18"}
                                        viewBox="0 0 24 24"
                                        fill="none"
                                        stroke="#b15cd6"
                                        strokeWidth="2"
                                    >
                                        <circle cx="11" cy="11" r="8" />
                                        <path d="m21 21-4.3-4.3" />
                                    </svg>
                                </button>
                            </div>
                        </div>
                    </div>
                </div>
            </div>

            {/* UPDATED CARD GRID - SMALLER CARDS */}
            {/* UPDATED CARD GRID - RESPONSIVE CARDS */}
            {/* UPDATED CARD GRID - RESPONSIVE CARDS */}
            <div className="offers-containers" style={{
                display: 'grid',
                gridTemplateColumns: 'repeat(auto-fill, minmax(160px, 1fr))',
                gap: '1rem',
                padding: '1rem 1rem 7rem 1rem',
                justifyItems: 'center'
            }}>
                {filteredDishes.length > 0 ? (
                    filteredDishes.map((item) => (
                        <div key={item.dishId} className="offers-cards" style={{
                            width: '100%',
                            maxWidth: '180px',
                            borderRadius: '0.75rem',
                            overflow: 'hidden',
                            boxShadow: '0 4px 12px rgba(0, 0, 0, 0.1)',
                            background: 'white',
                            transition: 'all 0.3s ease',
                            border: '1px solid #f0f0f0',
                            display: 'flex',
                            flexDirection: 'column',
                            height: '100%'
                        }}>
                            {/* Image */}
                            <div style={{ position: 'relative' }}>
                                {/* <img
            src={item.dishImage || "default-image.jpg"}
            alt="Dish"
            style={{
                width: '100%',
                height: '120px',
                objectFit: 'cover'
            }}
        /> */}
                            </div>

                            {/* Content */}
                            <div style={{
                                padding: '0.75rem',
                                display: 'flex',
                                flexDirection: 'column',
                                flexGrow: 1
                            }}>
                                {/* Title and Veg/Non-Veg Icon */}
                                <div style={{
                                    display: "flex",
                                    alignItems: "flex-start",
                                    justifyContent: "space-between",
                                    marginBottom: "0.5rem"
                                }}>
                                    <h5 style={{
                                        fontSize: "1rem",
                                        margin: 0,
                                        fontWeight: "600",
                                        color: "#333",
                                        lineHeight: "1.2",
                                        flex: 1,
                                        marginRight: "0.5rem"
                                    }}>
                                        {item.dishName}
                                    </h5>

                                    {item.tag === "Veg" ? (
                                        <div style={{
                                            width: "12px",
                                            height: "12px",
                                            border: "1.5px solid green",
                                            borderRadius: "2px",
                                            position: "relative",
                                            flexShrink: 0,
                                            marginTop: "0.25rem"
                                        }}>
                                            <div style={{
                                                width: "6px",
                                                height: "6px",
                                                backgroundColor: "green",
                                                borderRadius: "50%",
                                                position: "absolute",
                                                top: "50%",
                                                left: "50%",
                                                transform: "translate(-50%, -50%)",
                                            }}></div>
                                        </div>
                                    ) : (
                                        <div style={{
                                            width: "12px",
                                            height: "12px",
                                            border: "1.5px solid red",
                                            borderRadius: "2px",
                                            position: "relative",
                                            flexShrink: 0,
                                            marginTop: "0.25rem"
                                        }}>
                                            <div style={{
                                                width: "6px",
                                                height: "6px",
                                                backgroundColor: "red",
                                                borderRadius: "50%",
                                                position: "absolute",
                                                top: "50%",
                                                left: "50%",
                                                transform: "translate(-50%, -50%)",
                                            }}></div>
                                        </div>
                                    )}
                                </div>

                                {/* This spacer pushes the pricing and button to the bottom */}
                                <div style={{ flexGrow: 1 }}></div>

                                {/* Pricing */}
                                <div style={{
                                    display: 'flex',
                                    alignItems: 'center',
                                    gap: '0.5rem',
                                    marginBottom: '0.75rem'
                                }}>
                                    <span style={{
                                        fontSize: '0.8rem',
                                        color: 'gray',
                                        textDecoration: 'line-through'
                                    }}>
                                        <i className="fa-solid fa-indian-rupee-sign" style={{ fontSize: '0.7rem' }}></i>
                                        {item.price}
                                    </span>
                                    <span style={{
                                        fontSize: '0.9rem',
                                        fontWeight: 'bold',
                                        color: '#333'
                                    }}>
                                        <i className="fa-solid fa-indian-rupee-sign" style={{ fontSize: "0.7rem" }}></i>
                                        {item.effectivePrice}
                                    </span>
                                </div>

                                {/* Add to Cart Button */}
                                <div style={{ textAlign: "center" }}>
                                    {cartData.cartItems?.some(ci => ci.dishId === item.dishId) || quantities[item.dishId] > 0 ? (
                                        <div style={{
                                            display: 'flex',
                                            justifyContent: 'space-between',
                                            alignItems: 'center',
                                            background: '#b15dc6',
                                            borderRadius: '1.5rem',
                                            padding:window.innerWidth<900 ? " " : '0.25rem 0.5rem',
                                            color: 'white'
                                        }}>
                                            <button
                                                onClick={() => decreaseQuantity(item.dishId)}
                                                style={{
                                                    background: 'none',
                                                    border: 'none',
                                                    color: 'white',
                                                    fontSize: '1rem',
                                                    cursor: 'pointer',
                                                    padding: '0.25rem'
                                                }}
                                            >
                                                -
                                            </button>
                                            <span style={{
                                                fontSize: '0.9rem',
                                                fontWeight: 'bold',
                                                minWidth: '1.5rem',
                                                textAlign: 'center'
                                            }}>
                                                {quantities[item.dishId] || 1}
                                            </span>
                                            <button
                                                onClick={() => increaseQuantity(item.dishId)}
                                                style={{
                                                    background: 'none',
                                                    border: 'none',
                                                    color: 'white',
                                                    fontSize: '1rem',
                                                    cursor: 'pointer',
                                                    padding: '0.25rem'
                                                }}
                                            >
                                                +
                                            </button>
                                        </div>
                                    ) : (
                                        <button
                                            onClick={async () => {
                                                setQuantities(prev => ({ ...prev, [item.dishId]: 1 }));
                                                await addToCart(item, 1);
                                            }}
                                            style={{
                                                background: "#b15dc6",
                                                color: "#fff",
                                                width: "100%",
                                                borderRadius: "1.5rem",
                                                padding: "0.5rem",
                                                border: "none",
                                                fontSize:window.innerWidth<500 ? "0.7rem" : "1rem",
                                                fontWeight: "500",
                                                cursor: "pointer"
                                            }}
                                        >
                                            Add To Cart
                                        </button>
                                    )}
                                </div>
                            </div>
                        </div>
                    ))
                ) : (
                    <div style={{
                        gridColumn: "1 / -1",
                        textAlign: "center",
                        padding: "3rem",
                        color: "#666",
                        fontSize: "1.1rem",
                        width: "100%"
                    }}>
                        {searchQuery ? `No dishes found matching "${searchQuery}"` : "No dishes available"}
                    </div>
                )}
            </div>



            {/* Remove Confirmation Modal */}
            <Modal
                isOpen={showRemoveConfirm}
                onRequestClose={cancelRemove}
                contentLabel="Remove Item Confirmation"
                style={{
                    overlay: {
                        backgroundColor: "rgba(0, 0, 0, 0.5)",
                        display: "flex",
                        alignItems: "center",
                        justifyContent: "center",
                        zIndex: 9999
                    },
                    content: {
                        position: "relative",
                        top: "auto",
                        left: "auto",
                        right: "auto",
                        bottom: "auto",
                        width: "90%",
                        maxWidth: "400px",
                        margin: "0 auto",
                        border: "none",
                        borderRadius: "10px",
                        padding: "2rem",
                        textAlign: "center",
                        boxShadow: "0 4px 20px rgba(0, 0, 0, 0.15)"
                    }
                }}
            >
                <div style={{ textAlign: "center" }}>
                    <h3 style={{
                        color: "#2d3748",
                        marginBottom: "1rem",
                        fontSize: "1.3rem"
                    }}>
                        Remove Item
                    </h3>
                    <p style={{
                        color: "#718096",
                        marginBottom: "2rem",
                        fontSize: "1rem",
                        lineHeight: "1.5"
                    }}>
                        Are you sure you want to remove<br />
                        <strong>"{itemToRemove?.cartItem?.dishName}"</strong><br />
                        from your cart?
                    </p>
                    <div style={{
                        display: "flex",
                        gap: "1rem",
                        justifyContent: "center"
                    }}>
                        <button
                            onClick={cancelRemove}
                            style={{
                                padding: "0.75rem 1.5rem",
                                border: "2px solid #e2e8f0",
                                background: "white",
                                color: "#4a5568",
                                borderRadius: "0.5rem",
                                cursor: "pointer",
                                fontWeight: "600",
                                fontSize: "1rem",
                                transition: "all 0.2s ease"
                            }}
                            onMouseOver={(e) => {
                                e.target.style.borderColor = "#b15cd6";
                                e.target.style.color = "#b15cd6";
                            }}
                            onMouseOut={(e) => {
                                e.target.style.borderColor = "#e2e8f0";
                                e.target.style.color = "#4a5568";
                            }}
                        >
                            Cancel
                        </button>
                        <button
                            onClick={confirmRemove}
                            style={{
                                padding: "0.75rem 1.5rem",
                                border: "none",
                                background: "#e53e3e",
                                color: "white",
                                borderRadius: "0.5rem",
                                cursor: "pointer",
                                fontWeight: "600",
                                fontSize: "1rem",
                                transition: "all 0.2s ease"
                            }}
                            onMouseOver={(e) => {
                                e.target.style.background = "#c53030";
                            }}
                            onMouseOut={(e) => {
                                e.target.style.background = "#e53e3e";
                            }}
                        >
                            Remove
                        </button>
                    </div>
                </div>
            </Modal>
            <style>
                {`
        /* Existing styles... */

        /* Responsive Grid for Cards */
        .offers-containers {
            display: grid;
            grid-template-columns: repeat(auto-fill, minmax(150px, 1fr));
            gap: 1rem;
            padding: 1rem;
            justify-items: center;
        }

        .offers-cards {
            width: 100%;
            max-width: 180px;
            border-radius: 0.75rem;
            overflow: hidden;
            box-shadow: 0 4px 12px rgba(0, 0, 0, 0.1);
            background: white;
            transition: all 0.3s ease;
            border: 1px solid #f0f0f0;
        }

        .offers-cards:hover {
            transform: translateY(-4px);
            box-shadow: 0 8px 20px rgba(0, 0, 0, 0.15);
        }

        /* Mobile First: 1-2 cards */
        @media (max-width: 479px) {
            .offers-containers {
                grid-template-columns: repeat(auto-fit, minmax(140px, 1fr));
                gap: 0.75rem;
                padding: 0.75rem;
            }
            .offers-cards {
                max-width: 160px;
            }
        }

        /* Small Tablets: 2 cards */
        @media (min-width: 480px) and (max-width: 639px) {
            .offers-containers {
                grid-template-columns: repeat(2, 1fr);
                gap: 1rem;
            }
            .offers-cards {
                max-width: 100%;
            }
        }

        /* Tablets: 2-3 cards */
        @media (min-width: 640px) and (max-width: 799px) {
            .offers-containers {
                grid-template-columns: repeat(2, 1fr);
                gap: 1.25rem;
            }
            .offers-cards {
                max-width: 100%;
            }
        }

        /* Desktop: 3 cards from 800px */
        @media (min-width: 800px) and (max-width: 1023px) {
            .offers-containers {
                grid-template-columns: repeat(3, 1fr);
                gap: 1.5rem;
                padding: 1.5rem;
            }
            .offers-cards {
                max-width: 100%;
            }
        }

        /* Large Desktop: 4+ cards */
        @media (min-width: 1024px) and (max-width: 1279px) {
            .offers-containers {
                grid-template-columns: repeat(auto-fit, minmax(180px, 1fr));
                gap: 1.5rem;
            }
        }

        @media (min-width: 1280px) {
            .offers-containers {
                grid-template-columns: repeat(auto-fit, minmax(200px, 1fr));
                gap: 2rem;
            }
        }

        /* Card content adjustments for better responsiveness */
        @media (max-width: 639px) {
            .offers-cards {
                padding: 0.5rem;
            }
            .card-title {
                font-size: 0.8rem !important;
            }
        }

        @media (min-width: 800px) and (max-width: 1023px) {
            .offers-cards {
                padding: 0.75rem;
            }
        }

        /* Existing other styles... */
    `}
            </style>

        </div>
    );
};

export default MenuItems;




